import React, { PureComponent } from 'react'
import { Modal, Row, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import ImageZoom from 'react-image-magnifier-zoom'
import ImgPage from '../../../../../containers/commons/general/ImgPage'
import SmallLoaderPage from '../../../../../containers/commons/SmallLoaderPage'
import InputSelect from '../../../../../components/commons/form/InputSelect'
import InputText from '../../../../../components/commons/form/InputText'
import InputNatural from '../../../../../components/commons/form/InputNatural'
import InputMoney from '../../../../../components/commons/form/InputMoney'
import InputDecimal from '../../../../../components/commons/form/InputDecimal'
import InputDatePicker from '../../../../../components/commons/form/InputDatePicker'
import InputCheckBox from '../../../../../components/commons/form/InputCheckBox'
import SimpleInputText from '../../../../../components/commons/simpleForm/SimpleInputText'
import { typeView as typeViewConstant } from '../../../../../constants/dossier/common/documentTypeView'
import { /* documentStatus as documentStatusConstant, */ translateDocumentStatus, documentStatusClass, /* translateSignatureStatus, */ sealStatus } from '../../../../../constants/dossier/common/documentStatus'
import { typeFields as typeFieldsConstant, codeMetadataFields } from '../../../../../constants/dossier/common/typeFields'
import { dossierTypes as dossierTypesConstant } from '../../../../../constants/dossier/common/dossierTypes'
import { dossierSubTypeId as dossierSubTypeIdConstants } from '../../../../../constants/dossier/common/dossierSubType'
import settings from '../../../../../setting'
import DropZone from 'react-dropzone'
import RejectCommentModal from '../../../../../components/dossiers/common/RejectCommentModal'
import CancelSignModal from '../../../../../components/dossiers/common/CancelSignModal'
import { validateDate, validateRegex, customValidations, getAccepFiles, validateLicensePlate as validateLicensePlateFunciton, validateMetadatoByCode } from '../../../../../util/validationFunctions'
import { multipleNormalize, toUpperCase, trimAll } from '../../../../../util/normalizeFunctions'
import { entityTypesId as entityTypes, backEndIdDocumentStatus, documentTypeUse as documentTypeUseConstants, urgencyTypesClass } from '../../../../../constants/backendIds'
import SignTypesModal from '../../../../../components/dossiers/common/SignTypesModal'
import TrackingContainer from '../../../../../containers/tracking/trackingContainer'
import { CustomDimensionsConstant } from '../../../../../constants/tracking/CustomDimensionsConstant'
import { TrackingActions } from '../../../../../constants/tracking/TrackingActions'
import { currencies } from '../../../../../constants/dossier/common/currencies'
import { languages } from '../../../../../constants/dossier/common/languages'
import { amountToWordsCurrencyTextType, fleetMode } from '../../../../../constants/dossier/common/documentEditionModal'
import { numberToWords, numberToWordsI18n, capitalizeFirstLetter, handleKeyDown } from '../../../../../util/utils'
import { fromTemplate } from '../../../../../constants/filesToUpload'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileArrowUp } from '@fortawesome/free-solid-svg-icons'
import ReservationContractModalPage from '../../../../../containers/dossiers/common/ReservationContractModalPage'
import InternalManagementDocModalPage from '../../../../../containers/dossiers/common/templateModals/InternalManagementDocModalPage'
import { templateDataFormCode } from '../../../../../constants/dossier/common/templateDataFormCode'
import ResponsibleDeclarationDocModalPage from '../../../../../containers/dossiers/common/templateModals/ResponsibleDeclarationDocModalPage'

import PopoverItem from '../../../../../containers/search/PopoverItemPage'
import DossierListPopover from '../../../../../components/search/DossierListPopover'

const averageCharacter = 'c'
class DocumentEdition extends PureComponent {
  getColorBySignateStatus (value) {
    switch (parseInt(value)) {
      case 0:
        return 'WarningMedium'
      case 1:
        return 'WarningLow'
      case 2:
        return 'WarningCancel'
      case 3:
        return 'WarningCancel'
      case 5:
        return 'WarningCancel'
      case -1:
        return 'WarningPrimary'
      default:
        return ''
    }
  }

  constructor (props) {
    super(props)
    this.state = {
      actualDossierCharged: null,
      onDropfileUploadSheet: false,
      onDropfileUpload: false,
      invisible: true,
      documentTitle: averageCharacter,
      documentTitleCharWidth: null,
      documentTitleCharLimit: null,
      showTitle: false,
      files: [],
      selectedDocType: null,
      showRejectCommentModal: false,
      showCancelSignModal: false,
      showSignTypesModal: false,
      hasNewDocument: false,
      showFileUploader: false,
      showSheets: false,
      showMissingDocumentTypeError: false,
      hasInvalidFile: false,
      showDocumentCarrusel: false,
      autoCloseDocumentCarrusel: false,
      isDocumentCarruselEndReached: false,
      showPageCarrusel: true,
      autoClosePageCarrusel: false,
      signTypesCombo: [],
      zoomProps: {
        width: 0,
        height: 0,
        zoomWidth: 0,
        scale: 0.9,
        img: '',
        offset: { vertical: 0, horizontal: 10 },
        zoomPosition: 'original'
      },
      hasDropzoneImg: false,
      parametroFecha: Date.now(),
      dropzoneActive: false,
      dropzonePanelActive: false,
      carouselItemsPerPage: 20,
      carouselPaginationIdx: 1,
      signStatusId: null,
      documentId: null,
      cancelDocList: null,
      printTemplate: false,
      dossierDataGroupDATAOpen: true,
      dossierDataGroupFILESOpen: true,
      dossierDataGroupMETAOpen: true,
      dossierDataGroupFIELSSOpen: true,
      dossierDataGroupACTIONSOpen: true,
      dossierDataGroupOBSERVATIONSOpen: true,
      documentCount: 1
    }
    this.toggleFullScreenDocumentModal = this.toggleFullScreenDocumentModal.bind(this)
    this.toggleFullScreenDocumentSheetModal = this.toggleFullScreenDocumentSheetModal.bind(this)
    this.deleteDocumentSheet = this.deleteDocumentSheet.bind(this)
    this.cancelDocument = this.cancelDocument.bind(this)
    this.setActivePage = this.setActivePage.bind(this)
    this.updateImgSize = this.updateImgSize.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.onDragEnter = this.onDragEnter.bind(this)
    this.onDragLeave = this.onDragLeave.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.rejectDocument = this.rejectDocument.bind(this)
    this.documentTitleElementRef = React.createRef()
    this.validateDate = this.validateDate.bind(this)
    this.openCancelSignModal = this.openCancelSignModal.bind(this)
  }

  toggleDossierDataGroup (DataGroup) {
    switch (DataGroup) {
      case 'DATA': /* DataGroup_DATA */
      { this.setState({ dossierDataGroupDATAOpen: !this.state.dossierDataGroupDATAOpen })
        break }
      case 'FILES': /* DataGroup_FILES */
      { this.setState({ dossierDataGroupFILESOpen: !this.state.dossierDataGroupFILESOpen })
        break }
      case 'META': /* DataGroup_META */
      { this.setState({ dossierDataGroupMETAOpen: !this.state.dossierDataGroupMETAOpen })
        break }
      case 'FIELS': /* DataGroup_FIELS */
      { this.setState({ dossierDataGroupFIELSSOpen: !this.state.dossierDataGroupFIELSSOpen })
        break }
      case 'ACTIONS': /* DataGroup_ACTIONS */
      { this.setState({ dossierDataGroupACTIONSOpen: !this.state.dossierDataGroupACTIONSOpen })
        break }
      case 'OBSERVATIONS': /* DataGroup_ACTIONS */
      { this.setState({ dossierDataGroupOBSERVATIONSOpen: !this.state.dossierDataGroupOBSERVATIONSOpen })
        break }
    }
  }

  updateBaseTrackingAction () {
    this.baseTrackingAction = {
      href: window.location.href,
      documentTitle: this.props.dossierType + '_page',
      organizedUnitId: this.props.organizedUnitId,
      category: (this.props.dossierType === '' || !this.props.dossierType) ? '-' : this.props.dossierType,
      customDimensions: [
        { id: CustomDimensionsConstant.DOCUMENT_TYPE_ID, value: this.props.documentTypeId },
        { id: CustomDimensionsConstant.DOCUMENT_TYPE_USE_ID, value: this.props.documentTypeUseId },
        { id: CustomDimensionsConstant.DOCUMENT_TYPE_USE_NAME, value: this.props.documentTypeUseName }
      ]
    }
  }

  // La subida, validación, anulación, solicitud de firma, subida de hojas, borrado de hojas, apertura de la modal de documentos. Añadir información del documento si es posible.

  factoryOpenDocumentModalAction (dossierType, organizedUnitId, documentTypeUseId, documentTypeUseName) {
    this.updateBaseTrackingAction()
    var documentTypeuseDimension = this.baseTrackingAction.customDimensions.filter(x => x.id === CustomDimensionsConstant.DOCUMENT_TYPE_USE_ID)
    documentTypeuseDimension[0].value = documentTypeUseId

    dossierType = (dossierType === '' || !dossierType) ? '-' : dossierType

    var documentTypeuseNameDimension = this.baseTrackingAction.customDimensions.filter(x => x.id === CustomDimensionsConstant.DOCUMENT_TYPE_USE_NAME)
    documentTypeuseNameDimension[0].value = documentTypeUseName
    return { ...this.baseTrackingAction, action: TrackingActions.OPEN_DOCUMENT_MODAL, category: dossierType, organizedUnitId: organizedUnitId }
  }

  factoryCreateDocumentAction (documentType) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.CREATE_DOCUMENT }
  }

  factoryCreateDocumentSheetAction (file, documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.CREATE_DOCUMENT_SHEET }
  }

  factoryValidateDocumentAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.VALIDATE_DOCUMENT }
  }

  factorycancelDocumentAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.CANCEL_DOCUMENT }
  }

  factorySignRequestAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.SIGN_REQUEST }
  }

  factorySignCancelAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.SIGN_CANCEL }
  }

  factoryDeleteSheetAction (documentId) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.DELETE_SHEET }
  }

  factorySaveDocumentAction (documentType) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.SAVE_DOCUMENT }
  }

  factoryRejectDocumentAction (documentType) {
    this.updateBaseTrackingAction()
    return { ...this.baseTrackingAction, action: TrackingActions.REJECT_DOCUMENT }
  }

  ReturnFormatDocument (acceptFilesDropzone, tKey, t) {
    if (acceptFilesDropzone === '.jpg, .png, .jpeg') {
      return t(`${tKey}SELECT_FILES_PHOTO`)
    } else if (acceptFilesDropzone === 'application/pdf') {
      return t(`${tKey}SELECT_FILES_PDF`)
    } else {
      return t(`${tKey}SELECT_FILES`)
    }
  }

  ChangesList (idItem, idComponent, notDocument, documentId) {
    if (notDocument) {
      if (idItem === notDocument.toString()) {
        this.setState({
          canSave: true
        })
        if (documentId) {
          this.setState({
            onDropfileUpload: false
          })
        } else {
          this.setState({
            onDropfileUpload: true
          })
        }
      } else {
        this.setState({
          canSave: false
        })
      }
    }
    new Promise((resolve, reject) => {
      this.props.actions.checkDependenceMetadato(idComponent, resolve)
    }).then((result) => {
      if (result) {
        if (idItem === result.fieldDependenceValue && idComponent === result.fieldDependenceId) {
          this.setState({
            invisible: false
          })
        } else if (idItem !== result.fieldDependenceValue && idComponent === result.fieldDependenceId) {
          this.setState({
            invisible: true
          })
        }
      }
    })
  }

  closeModal (canShowAdvise = true) {
    new Promise((resolve, reject) => {
      const showAdvise = this.props.docResult &&
        this.props.docResult.buttonsPermission &&
        this.props.docResult.buttonsPermission.buttonSave &&
        this.props.docResult.fields && this.props.docResult.fields.length > 0 &&
        canShowAdvise && (this.state.hasNewDocument || !this.props.pristine)
      return this.props.actions.checkCanCloseDocumentModal(showAdvise, resolve)
    }).then((result) => {
      if (result) {
        const hasNewDoc = this.state.hasNewDocument
        this.setState({
          documentTitle: averageCharacter,
          documentTitleCharWidth: null,
          documentTitleCharLimit: null,
          showTitle: false,
          files: [],
          selectedDocType: null,
          hasNewDocument: false,
          showFileUploader: false,
          showSheets: false,
          showMissingDocumentTypeError: false,
          hasInvalidFile: false,
          zoomProps: { ...this.state.zoomProps, width: 0, height: 0, zoomWidth: 0, img: '' },
          hasDropzoneImg: false,
          showDocumentCarrusel: false,
          isDocumentCarruselEndReached: false,
          showPageCarrusel: true,
          dropzoneActive: false,
          dropzonePanelActive: false,
          carouselPaginationIdx: 1,
          canSave: false
        })
        this.props.initialize({})
        const refreshAfterChange = (hasNewDoc || !this.props.pristine) && (this.props.fleetMode === null || this.props.fleetMode === undefined)
        this.props.actions.closeAddOrEditDocumentModal(refreshAfterChange)
      }
    })
  }

  onDrop (fileToUpload, rejectedFiles, organizedUnitId) {
    if (fileToUpload.length === 0 && rejectedFiles.length > 0) {
      this.setState({ hasInvalidFile: true })
    } else {
      this.setState({ files: [fileToUpload[0]], hasNewDocument: true, hasInvalidFile: false })
      if (fileToUpload[0]) {
        if (this.props.docResult.documentId) {
          if (this.props.docResult.sheets.length === 0 && this.props.docResult.update !== true && this.props.docResult.storageDocumentId === null) {
            new Promise((resolve, reject) => {
              this.props.actions.createDocument('', this.props.checklistId, this.props.documentTypeUseId || this.state.selectedDocType, this.props.dossierId, resolve)
              this.props.trackAction(this.factoryCreateDocumentAction(this.state.selectedDocType))
            }).then((result) => {
              if (result) {
                this.props.actions.createDocumentSheet(this.state.files[0], result.organizedUnitId, result.documentId)
                this.setState({
                  actualDossierCharged: result.documentId
                })
                this.props.trackAction(this.factoryCreateDocumentSheetAction(this.state.files[0], result.documentId))
              }
            })
          } else {
            this.props.actions.createDocumentSheet(fileToUpload[0], organizedUnitId)
            this.props.trackAction(this.factoryCreateDocumentSheetAction(fileToUpload[0]))
          }
          this.setState({
            onDropfileUploadSheet: true
          })
        } else {
          if (!this.props.dossierIds) {
            if (this.props.docResult != null && this.props.docResult.chargeIdParent && this.props.docResult.buttonRefund) {
              this.props.actions.createDocument(fileToUpload[0], this.props.checklistId, this.props.documentTypeUseId || this.state.selectedDocType, this.props.dossierId, null, null, this.props.docResult.chargeIdParent)
            } else if (this.props.docResult != null && this.props.docResult.chargeId != null) {
              this.props.actions.createDocument(fileToUpload[0], this.props.checklistId, this.props.documentTypeUseId || this.state.selectedDocType, this.props.dossierId, null, this.props.docResult.chargeId)
            } else {
              this.props.actions.createDocument(fileToUpload[0], this.props.checklistId, this.props.documentTypeUseId || this.state.selectedDocType, this.props.dossierId)
            }
          } else {
            this.props.actions.createDocumentFleets(fileToUpload[0], this.props.checklistId, this.props.documentTypeUseId || this.state.selectedDocType, this.props.dossierIds, this.props.fleetMode === fleetMode.INCORPORATE_CHARGE ? this.props.organizedUnitId : null)
          }
          this.props.trackAction(this.factoryCreateDocumentAction(this.state.selectedDocType))
        }
        this.setState({
          onDropfileUpload: true
        })
      }
    }
  }

  handleGenerateAndUploadClick (templateFormCodeCalled = false, formValues = null) {
    if (this.props.templateFormCode && !templateFormCodeCalled) {
      this.templateDataForm(false)
    } else {
      let fileToUpload = { name: fromTemplate }
      this.props.actions.createDocument(fileToUpload, this.props.checklistId, this.props.documentTypeUseId || this.state.selectedDocType,
        this.props.dossierId, null, null, null, true, formValues)
      this.props.trackAction(this.factoryCreateDocumentAction(this.state.selectedDocType))
      this.setState({
        onDropfileUpload: true
      })
    }
  }

  onDragEnter (panel = false) {
    this.setState(panel ? { dropzonePanelActive: true } : { dropzoneActive: true })
  }

  onDragLeave (panel = false) {
    this.setState(panel ? { dropzonePanelActive: false } : { dropzoneActive: false })
  }

  changeAll (values) {
    Object.keys(values.entityValue).map(value => {
      this.props.change('AddOrEditDocumentForm', `entityValue.${value}`, values.entityValue[value])
    })
  }

  submitDocument (values, fleetsVisor) {
    if (this.props.fleetChargeId && this.props.fleetChargeId > -1) {
      this.updateFleetChargeDocument(values)
    } else {
      const errors = validateFunction(values, this.props)
      if (errors.entityValue && Object.keys(errors.entityValue || {}).length !== 0) return
      const valuesInFields = this.props.docResult.fields.map(field => {
        return {
          ...field, entityValue: values.entityValue[field.fieldId]
        }
      })
      if (values.validateAction) {
        this.props.actions.validateDocument(this.props.docResult.documentId, valuesInFields, values.comment)
        this.props.trackAction(this.factoryValidateDocumentAction(this.props.docResult.documentId))
      } else {
        if (this.props.docResult.update || this.props.docResult.sheets.length > 0) {
          this.props.actions.saveDocument(valuesInFields, values.comment, fleetsVisor)
        } else {
          this.props.actions.saveDocument(valuesInFields, values.comment, fleetsVisor)
          this.setState({
            onDropfileUpload: false,
            hasNewDocument: false
          })
        }
        this.props.trackAction(this.factorySaveDocumentAction())
      }
    }
  }

  submitFleetDocument (values) {
    if (this.props.fleetChargeId && this.props.fleetChargeId > -1) {
      this.updateFleetChargeDocument(values)
    } else {
      const errors = validateFunction(values, this.props)
      if (errors.entityValue && Object.keys(errors.entityValue || {}).length !== 0) return
      const valuesInFields = this.props.docResult.fields.map(field => {
        return {
          ...field, entityValue: values.entityValue[field.fieldId]
        }
      })
      if (values.validateAction) {
        this.props.actions.validateDocument(this.props.docResult.documentId, valuesInFields, values.comment)
        this.props.trackAction(this.factoryValidateDocumentAction(this.props.docResult.documentId))
      } else {
        let infoIncome = {
          documentTypeId: this.props.documentTypeUseId,
          fields: valuesInFields,
          comment: values.comment
        }

        let validateDocument = this.props.fleetMode === fleetMode.INCORPORATE_VALIDATE
        let fleetDocumentDetails = this.props.fleetDocumentDetails
        let otherDocuments = this.props.fleetMode === fleetMode.INCORPORATE_OTHER_DOCUMENTS

        if (otherDocuments) {
          fleetDocumentDetails = {}
          fleetDocumentDetails = this.props.dossieFleetIds?.map((doc) => {
            return { documentTypeId: this.props.documentTypeUseId, dossierId: doc }
          }
          )
        }

        if (this.props.docResult.update || this.props.docResult.sheets.length > 0) {
          this.props.actions.createIncorporateDocumentFleetProcess(this.state.files[0], this.props.documentTypeUseId, infoIncome, fleetDocumentDetails, this.props.fleetId, () => this.props.actions.closeAddOrEditDocumentModalSuccess(), validateDocument, otherDocuments)
        } else {
          this.props.actions.createIncorporateDocumentFleetProcess(this.state.files[0], this.props.documentTypeUseId, infoIncome, fleetDocumentDetails, this.props.fleetId, () => this.props.actions.closeAddOrEditDocumentModalSuccess(), validateDocument, otherDocuments)
          this.setState({
            onDropfileUpload: false,
            hasNewDocument: false
          })
        }
        this.props.trackAction(this.factorySaveDocumentAction())
      }
    }
  }

  validateFleetDocument (values) {
    const errors = validateFunction(values, this.props)
    if (errors.entityValue && Object.keys(errors.entityValue || {}).length !== 0) return
    const valuesInFields = this.props.docResult.fields.map(field => {
      return {
        ...field, entityValue: values.entityValue[field.fieldId]
      }
    })

    this.props.actions.createValidateDocumentFleetProcess(valuesInFields, values.comment, null, this.props.fleetDocumentDetails, this.props.fleetId, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
  }

  updateFleetChargeDocument (values) {
    const errors = validateFunction(values, this.props)
    if (errors.entityValue && Object.keys(errors.entityValue || {}).length !== 0) return
    const valuesInFields = this.props.docResult.fields.map(field => {
      return {
        ...field, entityValue: values.entityValue[field.fieldId]
      }
    })

    this.props.actions.createUpdateDocumentFleetChargeProcess(valuesInFields, values.comment, null, this.props.fleetDocumentDetails, this.props.fleetId, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
  }

  handleDocTypeChange (documentTypeId) {
    const documentType = this.props.combos.documentsTypes.find((documentsType) => documentsType.id === documentTypeId)
    if (documentType && documentType.id === documentTypeUseConstants.factory_invoice && !this.props.vehicleId) {
      this.props.change('documentType', null)
      this.props.actions.openModalVehicleNecessary()
    } else {
      if (!documentTypeId) this.setState({ files: [] })
      this.setState({ selectedDocType: documentTypeId, showMissingDocumentTypeError: !documentTypeId })

      if (!this.props.dossierIds) {
        this.props.actions.onDocumentTypeIdChange(documentTypeId, documentType.value)
      } else {
        this.props.actions.onDocumentTypeIdChangeFleets(documentTypeId, documentType.value, this.props.dossierIds)
      }
    }
  }

  copyMetaToEntityValues () {
    this.props.docResult.fields.forEach(field => {
      this.props.change(`entityValue.${field.fieldId}`, field.metaValue || '')
    })
  }

  uploadNewVersion () {
    this.setState({ hasNewDocument: true })
    this.props.docResult.fields.forEach(field => {
      this.props.change(`entityValue.${field.fieldId}`, '')
    })
    this.props.actions.uploadNewVersion()
  }

  rejectDocument (values, resolve, reject) {
    if (this.props.fleetChargeId && this.props.fleetChargeId > 0) {
      this.props.actions.setOperateActionRejectProcess({ text: this.props.t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.REJECT_REASON') }, [], this.props.fleetId, () => this.props.actions.closeAddOrEditDocumentModalSuccess(), this.props.fleetChargeId)
    } else {
      this.props.actions.rejectDocument(this.props.docResult.documentId, values, resolve, reject)
      this.props.trackAction(this.factoryRejectDocumentAction())
    }
  }

  toggleFullScreenDocumentModal (e) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentModal(this.props.docResult.documentId, false, this.props.organizedUnitId)
  }

  downloadDocument (e) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentModal(this.props.docResult.documentId, true, this.props.organizedUnitId)
  }

  refreshDocument (e) {
    e.stopPropagation()

    let date = Date.now()

    this.setState({
      parametroFecha: date,
      zoomProps: {
        ...this.state.zoomProps,
        img: `${settings.url}document/${this.props.docResult.documentId}/${this.props.activeSheet !== 0 ? `sheet/${this.props.activeSheet}/` : ''}preview?token=${this.props.token}${this.props.activePage && '&pageId=' + this.props.activePage}&fecha=${date}&organizedUnitId=${this.props.organizedUnitId}`
      }
    })
    this.props.actions.refreshDocResul(this.props.docResult.documentId)
  }

  toggleFullScreenDocumentSheetModal (e, sheetId) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentSheetModal(this.props.docResult.documentId, sheetId)
  }

  downloadDocumentSheet (e, sheetId) {
    e.stopPropagation()
    this.props.actions.toggleFullScreenDocumentSheetModal(this.props.docResult.documentId, sheetId, true)
  }

  deleteDocumentSheet (e, sheetId, organizedUnitId) {
    e.stopPropagation()
    new Promise((resolve, reject) => {
      var deleteDocumentSheetResult = this.props.actions.deleteDocumentSheet(this.props.docResult.documentId, sheetId, resolve, reject, organizedUnitId)
      this.props.trackAction(this.factoryDeleteSheetAction(this.props.docResult.documentId))
      return deleteDocumentSheetResult
    }).then(() => {
      const currentDate = Date.now()
      this.setActivePage(0, 1)
      let img = img = `${settings.url}document/${this.props.docResult.documentId}/${this.props.activeSheet !== 0 ? `sheet/${this.props.activeSheet}/` : ''}preview?token=${this.props.token}&fecha=${currentDate}&organizedUnitId=${organizedUnitId}`
      if (this.props.docResult.sheets.length === 0 || this.props.activeSheet === 0) {
        img = `${settings.url}document/${this.props.docResult.documentId}/preview?token=${this.props.token}&pageId=1&fecha=${currentDate}&organizedUnitId=${organizedUnitId}`
      }
      this.setState({
        parametroFecha: currentDate,
        zoomProps: {
          ...this.state.zoomProps,
          img: img
        }
      })
    })
  }

  getDocumentTitle (props) {
    const tKey = 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.ADD_OR_EDIT_DOCUMENT.'
    return (props.docResult.documentId ? props.t(`${tKey}EDIT`) : props.t(`${tKey}ADD`)) + (props.documentTypeUseName ? (' - ' + props.documentTypeUseName) : '')
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    let docDate = this.state.parametroFecha
    if (this.props.showDocumentEditionModal && !nextProps.showDocumentEditionModal) {
      this.setState({
        documentTitle: averageCharacter,
        documentTitleCharWidth: null,
        documentTitleCharLimit: null,
        showTitle: false,
        files: [],
        selectedDocType: null,
        dropzoneActive: false,
        dropzonePanelActive: false,
        carouselPaginationIdx: 1,
        canSave: false,
        hasNewDocument: false
      })
    }
    if (!this.props.showDocumentEditionModal && nextProps.showDocumentEditionModal) {
      /* nextProps.actions.setWindowDimensions(nextProps.windowWidth - 100, nextProps.windowHeight)
      window.setTimeout(() => nextProps.actions.setWindowDimensions(nextProps.windowWidth, nextProps.windowHeight), 100) */
      this.props.trackAction(this.factoryOpenDocumentModalAction(nextProps.dossierType, nextProps.organizedUnitId, nextProps.documentTypeUseId, nextProps.documentTypeUseName))
    }

    if (nextProps.docResult && nextProps.docResult.documentId) {
      docDate = Date.now()
      if (this.state.documentId === nextProps.docResult.documentId && this.state.signStatusId !== nextProps.docResult.signStatusId) {
        this.setState({ parametroFecha: docDate })
      }

      this.setState({
        signStatusId: nextProps.docResult.signStatusId,
        documentId: nextProps.docResult.documentId
      })
    }

    if (nextProps.docResult && nextProps.docResult.documentId &&
      (
        this.props.docResult.documentId !== nextProps.docResult.documentId ||
        this.props.activeSheet !== nextProps.activeSheet ||
        this.props.activePage !== nextProps.activePage
      )
    ) {
      let organizedUnitId = this.props.organizedUnitId ?? nextProps.organizedUnitId
      // if (this.props.fleetMode === fleetMode.INCORPORATE_VALIDATE || this.props.fleetMode === fleetMode.INCORPORATE || this.props.fleetMode === fleetMode.INCORPORATE_CHARGE || this.props.fleetMode === fleetMode.INCORPORATED_CHARGE) {
      //   organizedUnitId = null
      // }

      this.setState({
        zoomProps: {
          ...this.state.zoomProps,
          img: `${settings.url}document/${nextProps.docResult.documentId}/${nextProps.activeSheet !== 0 ? `sheet/${nextProps.activeSheet}/` : ''}preview?token=${nextProps.token}${nextProps.activePage && '&pageId=' + nextProps.activePage}&fecha=${docDate}&organizedUnitId=${organizedUnitId}`
        }
      })
    }

    if (nextProps.docResult.fields !== this.props.docResult.fields && this.props.metaLoading) {
      const fields = { metaValue: {} }
      nextProps.docResult.fields && nextProps.docResult.fields.length && nextProps.docResult.fields.forEach(field => {
        fields.metaValue[field.fieldId] = field.metaValue === undefined ? null : field.metaValue
      })
      this.props.change('fields', fields)
    } else if (nextProps.docResult.fields !== this.props.docResult.fields) {
      const fields = { entityValue: {}, metaValue: {} }
      nextProps.docResult.fields && nextProps.docResult.fields.length && nextProps.docResult.fields.forEach(field => {
        fields.entityValue[field.fieldId] = field.entityValue
        fields.metaValue[field.fieldId] = field.metaValue === undefined ? null : field.metaValue
      })
      fields.documentType = nextProps.docResult.documentTypeId
      fields.comment = nextProps.docResult.comment
      this.props.initialize(fields)
    }

    if (nextProps.docResult.sheets.length !== this.props.docResult.sheets.length) {
      this.setState({ showSheets: nextProps.docResult.sheets.length > 0 })
    }
    if (nextProps.docResult.documentId !== this.props.docResult.documentId || !nextProps.docResult.documentId) {
      this.setState({ showFileUploader: !nextProps.docResult.documentId, showDocumentCarrusel: false })
    }

    if ((!this.props.showDocumentEditionModal && nextProps.showDocumentEditionModal) ||
        nextProps.docResult.fields !== this.props.docResult.fields ||
        this.props.activeSheet !== nextProps.activeSheet) {
      this.setState({
        showPageCarrusel: nextProps.docResult.numPages && (nextProps.activeSheet === 0 ? nextProps.docResult.numPages : (nextProps.docResult.sheets &&
         nextProps.activeSheet && nextProps.docResult.sheets.find((e) => e.id === nextProps.activeSheet) && nextProps.docResult.sheets.find((e) => e.id === nextProps.activeSheet).numPages) > 1)
      })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.showDocumentEditionModal && this.props.docResult) {
      if (this.state.documentTitleCharWidth === null && this.state.documentTitle === averageCharacter) {
        this.setState({
          documentTitle: averageCharacter.repeat(99),
          documentTitleCharWidth: this.documentTitleElementRef.offsetWidth
        })
      } else if (this.state.documentTitleCharLimit === null && this.documentTitleElementRef.current !== null && this.documentTitleElementRef.current.textContent === averageCharacter.repeat(99)) {
        this.setState({
          documentTitleCharLimit: Math.floor(this.documentTitleElementRef.offsetWidth / this.state.documentTitleCharWidth * 2)
        })
      } else if ((this.state.documentTitleCharLimit !== null && this.state.documentTitle === averageCharacter.repeat(99)) || this.props.documentTypeUseId !== prevProps.documentTypeUseId) {
        let documentTitle = this.getDocumentTitle(this.props)
        if (documentTitle.length > this.state.documentTitleCharLimit) {
          documentTitle = documentTitle.substring(0, this.state.documentTitleCharLimit) + '...'
        }
        this.setState({ documentTitle, showTitle: true })
      }
    }
    const dropzoneImg = document.querySelector('.dropzone-img-wrapper > div img')
    if (this.state.zoomProps.img && this.props.windowWidth !== 0 && this.props.windowHeight !== 0 &&
      (
        (!this.state.hasDropzoneImg && dropzoneImg) ||
        this.state.zoomProps.img !== prevState.zoomProps.img ||
        this.state.showPageCarrusel !== prevState.showPageCarrusel ||
        this.props.windowWidth !== prevProps.windowWidth || this.props.windowHeight !== prevProps.windowHeight
      )
    ) {
      if (dropzoneImg) {
        if (this.state.zoomProps.img === prevState.zoomProps.img && dropzoneImg.naturalWidth > 0) {
          this.updateImgSize(dropzoneImg)
        } else {
          if (dropzoneImg.naturalWidth > 0) {
            dropzoneImg.src = ''
            dropzoneImg.src = this.state.zoomProps.img
          }
          dropzoneImg.addEventListener('load', (e) => {
            this.updateImgSize(e.currentTarget)
          })
        }
      }
      if (this.state.hasDropzoneImg !== !!dropzoneImg) this.setState({ hasDropzoneImg: !!dropzoneImg })
    }

    if (this.props.pristine) {
      this.isFunctionToBeExecutedInFrontActive() && this.props.docResult.fields.map(field => this.executeFieldFunction(field, this.props.docResult.fields, field.entityValue))
    }
  }

  toggleDocumentCarrusel () {
    this.setState({
      showDocumentCarrusel: !this.state.showDocumentCarrusel
    })
  }

  togglePageCarrusel () {
    this.setState({
      showPageCarrusel: !this.state.showPageCarrusel
    })
  }

  toggleCloud () {
    this.setState({
      showDocumentCarrusel: true
    })
  }

  setActivePage (sheetId, pageId) {
    if (this.props.activeSheet !== sheetId) {
      this.setState({ autoCloseDocumentCarrusel: true })
    } else if (this.props.activePage !== pageId) {
      this.setState({ autoClosePageCarrusel: true })
    }
    this.props.actions.setActivePage(sheetId, pageId)
  }

  fileCarruselMouseLeave () {
    if (this.state.autoCloseDocumentCarrusel) {
      this.setState({ autoCloseDocumentCarrusel: false })
      this.toggleDocumentCarrusel()
    }
  }

  pageCarruselMouseLeave () {
    if (this.state.autoClosePageCarrusel) {
      this.setState({ autoClosePageCarrusel: false })
      this.togglePageCarrusel()
    }
  }

  scrollToFile (side = 1) {
    const initialScrollPosition = this.refs.horizontalScrollWrapper.scrollTop
    const thumbnailWidth = 215
    let allowedMovement = (this.state.isDocumentCarruselEndReached || thumbnailWidth)
    if (allowedMovement < thumbnailWidth / 2) allowedMovement += thumbnailWidth
    const totalTimePerStep = 100
    const distancePerInterval = Math.round(allowedMovement / totalTimePerStep) * side
    let currentDistance = 0
    let lastScroll

    const interval = window.setInterval(() => {
      lastScroll = this.refs.horizontalScrollWrapper.scrollTop
      currentDistance += distancePerInterval
      this.refs.horizontalScrollWrapper.scrollTop += distancePerInterval
      if ((currentDistance * side) >= allowedMovement || lastScroll === this.refs.horizontalScrollWrapper.scrollTop) {
        if (this.state.isDocumentCarruselEndReached) {
          this.setState({ isDocumentCarruselEndReached: false })
        } else if (Math.abs(initialScrollPosition - this.refs.horizontalScrollWrapper.scrollTop) < allowedMovement) {
          this.setState({ isDocumentCarruselEndReached: Math.abs(initialScrollPosition - this.refs.horizontalScrollWrapper.scrollTop) })
        }
        window.clearInterval(interval)
      }
    }, totalTimePerStep / allowedMovement)
  }

  cancelDocument (dossierType, documentId, documentParentTypeId, dossierId, isRecurrent, fleetsVisor) {
    new Promise((resolve, reject) => {
      var cancelDocumetResult = this.props.actions.cancelDocument(dossierType, documentId, documentParentTypeId, dossierId, resolve, reject, isRecurrent, fleetsVisor)
      this.props.trackAction(this.factorycancelDocumentAction(documentId))
      return cancelDocumetResult
    }).then(() => {
      this.props.actions.closeAddOrEditDocumentModalSuccess()
      this.setState({
        documentTitle: averageCharacter,
        documentTitleCharWidth: null,
        documentTitleCharLimit: null,
        showTitle: false,
        files: [],
        selectedDocType: null,
        hasNewDocument: false,
        showFileUploader: false,
        showSheets: false,
        showMissingDocumentTypeError: false,
        hasInvalidFile: false,
        zoomProps: { ...this.state.zoomProps, width: 0, height: 0, zoomWidth: 0, img: '' },
        hasDropzoneImg: false,
        showDocumentCarrusel: false,
        isDocumentCarruselEndReached: false,
        showPageCarrusel: true,
        dropzoneActive: false,
        dropzonePanelActive: false,
        carouselPaginationIdx: 1,
        canSave: false
      })
      this.props.initialize({})
    })
  }

  sendDMS () {
    this.props.actions.sendDMS(this.props.docResult?.chargeId)
  }

  sealDocument (documentId, dossierId) {
    this.props.actions.sealStampDocument(documentId, dossierId)
  }

  updateImgSize (dropzoneImg) {
    const allowWidth = this.props.windowWidth / 2 - (this.state.showPageCarrusel ? 120 : 60) - 20
    const allowHeight = this.props.windowHeight - 80 - 140
    let percentToReduce = 1
    if (dropzoneImg.naturalWidth > allowWidth) {
      percentToReduce = Math.min(percentToReduce, (allowWidth / dropzoneImg.naturalWidth))
    }
    if (dropzoneImg.naturalHeight > allowHeight) {
      percentToReduce = Math.min(percentToReduce, (allowHeight / dropzoneImg.naturalHeight))
    }
    if (percentToReduce < 1) {
      this.setState({
        zoomProps: {
          ...this.state.zoomProps,
          width: parseInt(dropzoneImg.naturalWidth * percentToReduce),
          height: dropzoneImg.naturalHeight * percentToReduce,
          zoomWidth: dropzoneImg.naturalWidth * percentToReduce
        }
      })
    } else {
      this.setState({
        zoomProps: {
          ...this.state.zoomProps,
          width: parseInt(dropzoneImg.naturalWidth),
          height: dropzoneImg.naturalHeight,
          zoomWidth: dropzoneImg.naturalWidth
        }
      })
    }
  }

  nextCarouselPage (val) {
    let carouselPaginationIdx = 0
    if (val === -1) {
      carouselPaginationIdx = this.state.carouselPaginationIdx - 1 === 0 ? 1 : this.state.carouselPaginationIdx - 1
    } else {
      carouselPaginationIdx = this.state.carouselPaginationIdx ? this.state.carouselPaginationIdx + 1 : 2
    }

    let activeSheetIdx = 0
    if (this.props.docResult && this.props.docResult.sheets && this.props.activeSheet) {
      activeSheetIdx = this.props.docResult.sheets.findIndex((sheet, idx) => {
        return this.props.activeSheet === sheet.id
      })
    }

    const initItem = carouselPaginationIdx > 1 ? (carouselPaginationIdx - 1) * this.state.carouselItemsPerPage + 1 : 1

    this.setActivePage(activeSheetIdx, initItem)
    this.setState({ carouselPaginationIdx: carouselPaginationIdx })
  }

  selectDocument (sheetId, pageId) {
    this.setActivePage(sheetId, pageId)
    this.setState({ carouselPaginationIdx: 1 })
  }

  getIconByStatus (signStatusId) {
    switch (parseInt(signStatusId)) {
      case 0:
        return 'ico-pending'
      case 1:
        return 'ico-ok'
      case 2:
        return 'ico-document-wrong'
      case 3:
        return 'ico-wrong'
      default:
        return 'ico-document'
    }
  }

  getSignStatusText (signStatusId) {
    switch (parseInt(signStatusId)) {
      case 0:
        return 'SIGN_PENDING'
      case 1:
        return 'SIGN_SIGNED'
      case 2:
        return 'SIGN_CANCELLED'
      case 3:
        return 'SIGN_REJECTED'
      case 5:
        return 'SIGN_EXPIRED'
      case -1:
        return 'SIGN_AVAILABLE'
      default:
        return 'SIGN_DEFAULT'
    }
  }

  signDocument (values, fleetsVisor) {
    const documentId = this.props.docResult.documentId
    const callback = this.props.callback
    const refreshAfterChange = this.props.refreshAfterChange

    new Promise((resolve, reject) => {
      return this.props.actions.signTypes(resolve, reject, documentId, null, null, this.props.pristine)
    }).then((result) => {
      if (result && result.length > 1) {
        this.setState({ signTypesCombo: result, showSignTypesModal: true })
      } else {
        if (this.props.fleetMode === fleetMode.REQUEST_SIGN) {
          if (result && result.length === 1) {
            this.props.actions.createRequestSignDocumentFleetProcess(this.props.fleetDocumentDetails, this.props.fleetId, result[0].id, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
          } else {
            this.props.actions.createRequestSignDocumentFleetProcess(this.props.fleetDocumentDetails, this.props.fleetId, null, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
          }
        } else {
          if (this.props.docResult.data.entity.entityTypeId === undefined) {
            this.props.actions.openErrorMessageModal('ERRORS.BACKEND_TAG_TRANSLATION.SIGNATURE_CLIENT_NOT_FOUND')
          } else {
            this.changeAll(values)
            this.submitDocument(values, fleetsVisor)
            if (result && result.length === 1) {
              this.props.actions.requestSign(documentId, null, callback, refreshAfterChange, result[0].id)
            } else {
              this.props.actions.requestSign(documentId, null, callback, refreshAfterChange)
            }
          }
        }
      }
    }).catch(error => console.log(error))
  }

  executeFieldFunction (field, fields, value) {
    const tKey = 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.ADD_OR_EDIT_DOCUMENT.'
    switch (field.functionToExecuteInFront) {
      case 'chargeAmountToWords':
        var targetFieldCode = this.getCodeTargetFieldAmountToWords(field.code)
        var targetField = fields.find(x => x.code === targetFieldCode)
        if (value || value === '0') {
          if (!isNaN(value)) {
            var integerValue = Math.floor(Math.abs(value))
            var wordsFromIntegerNumber = numberToWords(integerValue, localStorage.localeName.split('-')[0])
            var currencyText = this.getAmountToWordsCurrencyText(localStorage.locale, wordsFromIntegerNumber, value, numberToWordsI18n(parseInt(localStorage.locale)), settings.currency)

            var decimalWords = ''
            var decimalValue = (Math.abs(value) % 1).toFixed(4).substring(2, 4)
            if (decimalValue && decimalValue > 0) {
              var wordsFromDecimalNumber = numberToWords(decimalValue, localStorage.localeName.split('-')[0])
              var centText = parseInt(decimalValue) === 1 ? this.props.t(`${tKey}CENT`) : this.props.t(`${tKey}CENTS`)
              decimalWords = `${wordsFromDecimalNumber} ` + centText
            }
            this.props.change(`entityValue.${targetField.fieldId}`, `${capitalizeFirstLetter(wordsFromIntegerNumber)} ${currencyText} ${decimalWords}`)
          }
        } else {
          this.props.change(`entityValue.${targetField.fieldId}`, '')
        }
        break

      default:
        break
    }
  }

  getAmountToWordsCurrencyText (languageId, wordsFromNumber, fieldValue, i18nObject, currency = currencies.EUR) {
    if (parseInt(fieldValue) === 1) return this.getBasicCurrencyText(languageId, amountToWordsCurrencyTextType.SINGLE, currency)
    var matchedSpecialCasesForCurrencyText = []
    if (i18nObject) {
      var unitsWithPluralWord = i18nObject.units.filter(x => !!x.plural)
      var wordsFromNumberWords = wordsFromNumber.split(' ')
      var wordsFromNumberLastWord = wordsFromNumberWords[wordsFromNumberWords.length - 1]
      matchedSpecialCasesForCurrencyText = unitsWithPluralWord.filter(x => x.plural === wordsFromNumberLastWord || x.singular === wordsFromNumberLastWord)
    }

    let currencyText = ''
    switch (parseInt(languageId)) {
      case languages.SPANISH:
      case languages.CATALAN:
      case languages.SPANISH_MX:
        var currencyTextType = matchedSpecialCasesForCurrencyText.length > 0 ? amountToWordsCurrencyTextType.SPECIAL_CASE : amountToWordsCurrencyTextType.PLURAL
        currencyText = this.getBasicCurrencyText(languageId, currencyTextType, currency)
        break
      case languages.ENGLISH:
      case languages.PORTUGUESE:
        currencyText = this.getBasicCurrencyText(languageId, amountToWordsCurrencyTextType.PLURAL, currency)
        break
    }

    return currencyText
  }

  getBasicCurrencyText (languageId, typeCurrencyText, currency) {
    var basicCurrencyText = ''
    switch (typeCurrencyText) {
      case amountToWordsCurrencyTextType.SINGLE:
        basicCurrencyText = settings.currencyTextConfig[parseInt(languageId)].single
        break

      case amountToWordsCurrencyTextType.PLURAL:
        basicCurrencyText = settings.currencyTextConfig[parseInt(languageId)].plural
        break

      case amountToWordsCurrencyTextType.SPECIAL_CASE:
        basicCurrencyText = settings.currencyTextConfig[parseInt(languageId)].special
        break
      default:
        break
    }

    return basicCurrencyText
  }

  getCodeTargetFieldAmountToWords (sourceFieldCode) {
    var targetField = ''
    switch (sourceFieldCode) {
      case codeMetadataFields.ABONO_IMPORTE:
        targetField = codeMetadataFields.ABONO_IMPORTE_TEXTO
        break

      case codeMetadataFields.COBRO_IMPORTE:
        targetField = codeMetadataFields.COBRO_IMPORTE_TEXTO
        break

      case codeMetadataFields.PAGA_SEÑAL_IMPORTE:
        targetField = codeMetadataFields.PAGA_SEÑAL_IMPORTE_TEXTO
        break
      default:
        break
    }

    return targetField
  }

  customValidate (value, allValues, props, field) {
    const id = parseInt(field.split('entityValue.')[1])
    const fieldFound = props.docResult.fields !== null ? props.docResult.fields.find(f => f.fieldId === id) : null
    if (fieldFound && fieldFound.customValidations) {
      const result = customValidations(fieldFound.customValidations, value, props)
      return result === Object(result) ? undefined : result
    }
  }

  isFunctionToBeExecutedInFrontActive () {
    return this.props.docResult.isActiveAutoChargeAmountToWords
  }

  validateDate (value, allValues, props, field) {
    const id = parseInt(field.split('entityValue.')[1])
    const fieldFound = props.docResult.fields !== null ? props.docResult.fields.find(f => f.fieldId === id) : null
    let result = validateDate(value, props)
    if (result === Object(result) && fieldFound && fieldFound.customValidations) {
      result = customValidations(fieldFound.customValidations, value, props)
    }
    return result === Object(result) ? undefined : result
  }

  closeModalAction () {
    this.setState({ showSignTypesModal: false })
  }

  openCancelSignModal () {
    new Promise((resolve, reject) => {
      return this.props.actions.getCancelDocListAction(this.props.docResult.documentId, null, resolve, reject)
    }).then((result) => {
      this.setState({ showCancelSignModal: true, cancelDocList: result })
    }).catch(error => console.log(error))
  }

  closeModalFleet () {
    new Promise((resolve, reject) => {
      return this.props.actions.checkCanCloseDocumentModal(true, resolve)
    }).then((result) => {
      if (result) {
        this.directCloseModal()
      }
    })
  }

  recoverDocumentFleet () {
    this.props.actions.createReEditDocumentFleetProcess(this.props.fleetDocumentDetails, this.props.fleetId, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
  }

  recoverDocumentFleetCharge () {
    this.props.actions.createRecoverDocumentFleetChargeProcess(this.props.fleetId, this.props.fleetChargeId, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
  }

  cancelDocumentFleet () {
    this.props.actions.createCancelDocumentFleetProcess(this.props.fleetDocumentDetails, this.props.fleetId, () => this.props.actions.closeAddOrEditDocumentModalSuccess())
  }

  cancelSignDocument () {
    this.props.actions.createCancelSignDocumentFleetProcess(this.props.fleetDocumentDetails, this.props.fleetId, this.props.t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.CANCEL_SIGN_REASON'), () => this.props.actions.closeAddOrEditDocumentModalSuccess())
  }

  rejectDocumentFleet () {
    this.props.actions.createRejectDocumentFleetProcess(this.props.fleetDocumentDetails, this.props.fleetId, this.props.t('MANAGEMENT.FLEETS_TAB.AUX_MODALS.REJECT_REASON'), () => this.props.actions.closeAddOrEditDocumentModalSuccess())
  }

  directCloseModal () {
    const hasNewDoc = this.state.hasNewDocument
    this.setState({
      documentTitle: averageCharacter,
      documentTitleCharWidth: null,
      documentTitleCharLimit: null,
      showTitle: false,
      files: [],
      selectedDocType: null,
      hasNewDocument: false,
      showFileUploader: false,
      showSheets: false,
      showMissingDocumentTypeError: false,
      hasInvalidFile: false,
      zoomProps: { ...this.state.zoomProps, width: 0, height: 0, zoomWidth: 0, img: '' },
      hasDropzoneImg: false,
      showDocumentCarrusel: false,
      isDocumentCarruselEndReached: false,
      showPageCarrusel: true,
      dropzoneActive: false,
      dropzonePanelActive: false,
      carouselPaginationIdx: 1,
      canSave: false
    })
    this.props.initialize({})
    this.props.actions.closeAddOrEditDocumentModal(hasNewDoc || !this.props.pristine)
  }

  viewFieldsFleet () {
    return this.props.fleetMode !== fleetMode.CANCEL && this.props.fleetMode !== fleetMode.REQUEST_SIGN && this.props.fleetMode !== fleetMode.CANCEL_SIGN && this.props.fleetMode !== fleetMode.REJECT
  }

  getSealStatus (sealStatusId) {
    switch (sealStatusId) {
      case null:
      case undefined:
      case sealStatus.PENDING_SEND:
        return 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.PENDING_SEND'
      case sealStatus.PENDING_SEAL:
        return 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.PENDING_SEAL'
      case sealStatus.SEALED:
        return 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.SEALED'
    }
  }

  printTemplate (templateFormCodeCalled = false, formValues = null) {
    if (this.props.templateFormCode && !templateFormCodeCalled) {
      this.templateDataForm(true)
    } else if (this.props.checklistId) {
      this.props.actions.printCheckList(this.props.checklistId, formValues)
    } else {
      this.props.actions.printTemplateByReferenceType(formValues)
    }
  }

  templateDataForm (printTemplate) {
    switch (this.props.templateFormCode) {
      case templateDataFormCode.ReservationContract:
        this.setState({ printTemplate: printTemplate })
        this.props.actions.fetchInsuranceCompanyCombo()
        this.props.actions.openReservationContractModal(this.props.dossierId)
        break
      case templateDataFormCode.InternalManagementDoc:
        this.setState({ printTemplate: printTemplate })
        this.props.actions.openInternalManagementDocModal(this.props.dossierId, this.props.checklistId, printTemplate, this.props.organizedUnitId)
        break
      case templateDataFormCode.ResponsibleDeclaration:
        this.setState({ printTemplate: printTemplate })
        this.props.actions.openResponsibleDeclarationDocModal(this.props.dossierId, this.props.checklistId, printTemplate, this.props.organizedUnitId)
        break
      default:
        if (printTemplate) {
          this.printTemplate(true)
        } else {
          this.handleGenerateAndUploadClick(true)
        }
        break
    }
  }

  handleSubmitReservationContractModal (formValues, printCheckList = false, checklistId = null) {
    if (printCheckList) {
      this.props.actions.printCheckList(checklistId, formValues)
    } else if (this.state.printTemplate) {
      this.printTemplate(true, formValues)
    } else {
      this.handleGenerateAndUploadClick(true, formValues)
    }
  }

  render () {
    let {
      t, showDocumentEditionModal, handleSubmit, documentTypeUseName, token, fleetsVisor, editable,
      documentTypeUseId, documentParentTypeId, dossierId, entityId, vehicleId, organizedUnitId, callback,
      refreshAfterChange, dossierType, dossierSubType, checkListIdReciboPagaYSenal, activeSheet, /* activePage, */
      isRecurrent, readOnlyFields, metaLoading, referenceType, referenceId,
      docResult: {
        documentId, typeView, documentStatusId, thumbnail,
        fields = [], comment, incorporationDate, sheets, numPages = 1, data, typeObject, signStatusId, signDate,
        solpheoDocumentId, storageDocumentId
      },
      actions: {
        openDocumentEditionModal,
        recoverDocument,
        cancelSign,
        requestSign,
        cancelSignMessage,
        createRequestSignDocumentFleetProcess,
        closeAddOrEditDocumentModalSuccess
      },
      combos: { documentsTypes },
      multipleSignCancel
    } = this.props
    let buttonUpload, buttonAddNewVersion, buttonNewSheet, buttonRecover, buttonDMS, buttonSave, buttonValidate, iconReload, validatedText, buttonReject, buttonCancel, buttonDownload, editRecurrentEntityDocuments, btnRequestSign, btnCancelSign, commentDocument, buttonDelete, buttonSeal
    if (this.props.docResult && this.props.docResult.buttonsPermission) {
      buttonUpload = this.props.docResult.buttonsPermission.buttonUpload && editable
      buttonAddNewVersion = this.props.docResult.buttonsPermission.buttonAddNewVersion && editable
      buttonNewSheet = this.props.docResult.buttonsPermission.buttonNewSheet && editable
      buttonRecover = this.props.docResult.buttonsPermission.buttonRecover && editable
      buttonDMS = this.props.docResult.buttonsPermission.buttonDMS && editable
      buttonSave = this.props.docResult.buttonsPermission.buttonSave && editable
      buttonValidate = this.props.docResult.buttonsPermission.buttonValidate && editable
      iconReload = this.props.docResult.buttonsPermission.iconReload && editable
      validatedText = this.props.docResult.buttonsPermission.validatedText && editable
      buttonReject = this.props.docResult.buttonsPermission.buttonReject && editable
      buttonCancel = this.props.docResult.buttonsPermission.buttonCancel && editable
      buttonDownload = this.props.docResult.buttonsPermission.buttonDownload
      editRecurrentEntityDocuments = this.props.docResult.buttonsPermission.editRecurrentEntityDocuments && editable
      btnRequestSign = this.props.docResult.buttonsPermission.buttonRequestSign && editable
      btnCancelSign = this.props.docResult.buttonsPermission.buttonCancelSign && editable
      commentDocument = this.props.docResult.buttonsPermission.commentDocument && editable
      buttonDelete = this.props.docResult.buttonsPermission.buttonDelete && editable
      buttonSeal = this.props.docResult.buttonsPermission.buttonSeal && editable
    } else {
      buttonUpload = buttonNewSheet = buttonRecover = buttonDMS = buttonSave = buttonValidate = iconReload = validatedText = buttonReject = buttonCancel = buttonDownload = commentDocument = false
    }
    signStatusId = String(signStatusId)
    const tKey = 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.ADD_OR_EDIT_DOCUMENT.'

    const statusTooltip = (<Tooltip id="statusTooltip">{documentStatusId && t(`DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.${translateDocumentStatus[documentStatusId]}`)}</Tooltip>)
    const viewSheetTooltip = (<Tooltip id="viewTooltip">{t(`${tKey}VIEW_SHEET_BTN`)}</Tooltip>)
    const downloadTooltip = (<Tooltip id="downloadTooltip">{t(`${tKey}DOWNLOAD_BTN`)}</Tooltip>)
    const deleteSheetTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE_SHEET_BTN`)}</Tooltip>)
    const copyValuesTooltip = (<Tooltip id="copyValuesTooltip">{t(`${tKey}COPY_VALUES`)}</Tooltip>)
    const refreshTooltip = (<Tooltip id="refreshTooltip">{t(`${tKey}REFRESH_BTN`)}</Tooltip>)
    const acceptFilesDropzone = getAccepFiles()
    const maxSizeFilesDropzone = 10240000

    const uploadNewVersionTooltip = (<Tooltip id="uploadNewVersionTooltip">{t(`${tKey}UPLOAD_NEW_VERSION`)}</Tooltip>)

    const signStatusIdAndDate = (
      <div className={'popover-item ' + (this.getColorBySignateStatus(this.state.signStatusId))}>
        <OverlayTrigger placement="right" overlay={<Tooltip id="popoverTooltip" className='popoverTooltip'>{t(`${tKey}SIGN_STATUS`)}</Tooltip>}>
          <i id="signatureStatus" className='iDocIcon-signature-draw'></i>
        </OverlayTrigger>
        <span>
          {t(`${tKey}` + this.getSignStatusText(this.state.signStatusId))}
          {signDate && <> <br/> <span className="number-exp">{t(`${tKey}SIGN_DATE`)}: <span className="sign-date">{signDate}</span></span> </>}
        </span>
      </div>
    )

    let permissionToEdit = data && data.entity && (data.entity.entityTypeId === entityTypes.recurrentEntity && typeObject === 1 ? editRecurrentEntityDocuments : true)
    permissionToEdit = permissionToEdit === undefined || permissionToEdit === null ? true : permissionToEdit
    const editTooltip = (<Tooltip id="editTooltip">{t('DOSSIER_COMPONENTS.VEHICLE.TOOLTIP_VALIDATE_LICENSE_PLATE')}</Tooltip>)
    documentParentTypeId = this.props.docResult.typeObject ? this.props.docResult.typeObject : documentParentTypeId

    const showGenerateButtons = this.props.showGenerateButtons && (this.props.checklistId != null || (referenceType && referenceId) || this.props.templateFormCode)
    const { onlyTemplateUpload } = this.props

    let organizedUnitPreview = organizedUnitId

    return (
      <>

        <Modal show={showDocumentEditionModal} className={'_vModal_2 document-edition-modal customScrollbar ' + (showGenerateButtons && !this.props.docResult.documentId ? ' no-document-modal' : '')} onHide={() => this.closeModal()}>
          <Modal.Header closeButton className='m-Header'>
            {documentStatusId && (
              <OverlayTrigger placement="right" overlay={statusTooltip}>
                <i id="documentStatus" className={'icono-heder-modal ico-document-' + documentStatusClass[translateDocumentStatus[documentStatusId]]}/>
              </OverlayTrigger>
            )}
            <h2 id="documentTitle" ref={this.documentTitleElementRef} className={'document-title' + (!this.state.showTitle ? ' invisible' : '')}>{this.state.documentTitle}</h2>
            {incorporationDate &&
              <div className="number-exp">
                <OverlayTrigger placement="right" overlay={<Tooltip id="001">{t(`${tKey}INCORPORATION_DATE`)}</Tooltip>}>
                  <i className="iDocIcon-date-range-create"></i>
                </OverlayTrigger>
                <span className="incorporation-date">{incorporationDate}</span>
              </div>
            }
          </Modal.Header>
          <Modal.Body className='m-Body'>

            {((!this.state.showFileUploader) && (solpheoDocumentId || storageDocumentId)) && (
              <div className='m-Body-Left'>
                <div className={'m-data-block ' + (this.state.dossierDataGroupDATAOpen ? 'unColapse' : 'colapse')}>
                  <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('DATA')} >
                    <div className='data-block-header-name'>
                      <span>{t(`${tKey}INFORMATION`)}</span>
                    </div>
                    <div className='data-block-header-actions'>
                      <i className="iDocIcon-caret-right-solid"></i>
                    </div>
                  </div>
                  <div className='data-block-body'>
                    { typeObject === 1 && ( // ENTITY
                      <>
                        {data?.entity.entityType && <PopoverItem itemType={'ent-1'} placement='right' data={data?.entity.entityType }></PopoverItem>}
                        {data?.entity.entityName && <PopoverItem itemType={'ent-2'} placement='right' data={data?.entity.entityName }></PopoverItem>}
                        {data?.entity.entityCifNif && <PopoverItem itemType={'ent-6'} placement='right' data={data?.entity.entityCifNif }></PopoverItem>}
                        {data?.entity.clientNumber && <PopoverItem itemType={'ent-5'} placement='right' data={data?.entity.clientNumber }></PopoverItem>}
                        {data?.entity.entityAddress && <PopoverItem itemType={'ent-7'} placement='right' data={data?.entity.entityAddress }></PopoverItem>}
                        {data?.entity.entityPhone && <PopoverItem itemType={'ent-8'} placement='right' data={data?.entity.entityPhone}></PopoverItem>}
                        {data?.entity.entityMail && <PopoverItem itemType={'ent-9'} placement='right' data={data?.entity.entityMail }></PopoverItem>}
                        <div className='popover-item dossierList'>
                          <DossierListPopover
                            t={t}
                            idx="exp-asociados1"
                            id={'popover-dossier-list'}
                            alive={data.lives}
                            stored={data.stored}
                            itemOverlayPlacement={'right'}
                          />
                        </div>
                        {!signStatusId && signStatusIdAndDate }
                      </>
                    )}
                    { typeObject === 2 && ( // VEHICLE
                      <>
                        {data?.vehicle.vehicleBrand && <PopoverItem itemType={'veh_06'} placement='right' data={data?.vehicle.vehicleBrand }></PopoverItem>}
                        {data?.vehicle.carline && <PopoverItem itemType={'veh_02'} placement='right' data={data?.vehicle.carline }></PopoverItem>}
                        {data?.vehicle.catalogue && <PopoverItem itemType={'veh_03'} placement='right' data={data?.vehicle.catalogue }></PopoverItem>}
                        {data?.vehicle.modelYear && <PopoverItem itemType={'veh_04'} placement='right' data={data?.vehicle.modelYear }></PopoverItem>}
                        {data?.vehicle.vehicleModel && <PopoverItem itemType={'veh_05'} placement='right' data={data?.vehicle.vehicleModel }></PopoverItem>}
                        {data?.vehicle.vehicleVinChassis && <PopoverItem itemType={'veh_12'} placement='right' data={data?.vehicle.vehicleVinChassis }></PopoverItem>}
                        {data?.vehicle.vehicleLicensePlate && <PopoverItem itemType={'veh_07'} placement='right' data={data?.vehicle.vehicleLicensePlate }></PopoverItem>}
                        {data?.vehicle.comercialCode && <PopoverItem itemType={'veh_08'} placement='right' data={data?.vehicle.comercialCode }></PopoverItem>}
                        {data?.vehicle.licensePlateDate && <PopoverItem itemType={'veh_09'} placement='right' data={data?.vehicle.licensePlateDate }></PopoverItem>}
                        {data?.vehicle.color && <PopoverItem itemType={'veh_10'} placement='right' data={data?.vehicle.color }></PopoverItem>}
                        {data?.vehicle.tapestry && <PopoverItem itemType={'veh_11'} placement='right' data={data?.vehicle.tapestry }></PopoverItem>}
                        <div className='popover-item dossierList'>
                          <DossierListPopover
                            t={t}
                            idx="exp-asociados1"
                            id={'popover-dossier-list'}
                            alive={data.lives}
                            stored={data.stored}
                            itemOverlayPlacement={'right'}
                          />
                        </div>
                        {!signStatusId && signStatusIdAndDate }
                      </>
                    )}
                    { typeObject === 3 && ( // DOSSIER
                      <>
                        {data?.dossier.number && <PopoverItem itemType={'doss_01'} placement='right' urgency={urgencyTypesClass[data?.dossier.urgencyType]} data={data?.dossier.number }></PopoverItem>}
                        {data?.dossier.subtype && <PopoverItem itemType={'doss_02'} placement='right' data={data?.dossier.subtype }></PopoverItem>}
                        {data?.dossier.stage && <PopoverItem itemType={'doss_03'} placement='right' data={data?.dossier.stage }></PopoverItem>}
                        {data?.dossier.organizedUnit && <PopoverItem itemType={'doss_04'} placement='right' data={data?.dossier.organizedUnit }></PopoverItem>}
                        {data?.dossier.salesman && <PopoverItem itemType={'doss_05'} placement='right' data={data?.dossier.salesman }></PopoverItem>}
                        {data?.vehicle.licensePlateDate && <PopoverItem itemType={'veh_09'} placement='right' data={data?.vehicle.licensePlateDate }></PopoverItem>}
                        {data?.entity.entityType && <PopoverItem itemType={'ent-1'} placement='right' data={data?.entity.entityType }></PopoverItem>}
                        {data?.entity.entityName && <PopoverItem itemType={'ent-2'} placement='right' data={data?.entity.entityName }></PopoverItem>}
                        {data?.entity.clientNumber && <PopoverItem itemType={'ent-5'} placement='right' data={data?.entity.clientNumber }></PopoverItem>}
                        {data?.entity.entityCifNif && <PopoverItem itemType={'ent-6'} placement='right' data={data?.entity.entityCifNif }></PopoverItem>}
                        {data?.entity.entityPhone && <PopoverItem itemType={'ent-8'} placement='right' data={data?.entity.entityPhone }></PopoverItem>}
                        {data?.entity.entityMail && <PopoverItem itemType={'ent-9'} placement='right' data={data?.entity.entityMail }></PopoverItem>}
                        {data?.vehicle?.vehicleModel && <PopoverItem itemType={'veh_05'} placement='right' data={data?.vehicle.vehicleModel }></PopoverItem>}
                        {data?.vehicle?.vehicleVinChassis && <PopoverItem itemType={'veh_12'} placement='right' data={data?.vehicle.vehicleVinChassis }></PopoverItem>}
                        {data?.vehicle?.vehicleLicensePlate && <PopoverItem itemType={'veh_07'} placement='right' data={data?.vehicle.vehicleLicensePlate }></PopoverItem>}
                      </>
                    )}
                    {this.state.signStatusId !== undefined && this.state.signStatusId !== null &&
                      signStatusIdAndDate
                    }
                  </div>
                </div>
                <div className={'m-data-block ' + (this.state.dossierDataGroupFILESOpen ? 'unColapse' : 'colapse')}>
                  <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('FILES')} >
                    <div className='data-block-header-name'>
                      <span>{t(`${tKey}FILES`)}</span>
                    </div>
                    <div className='data-block-header-actions'>
                      <i className="iDocIcon-caret-right-solid"></i>
                    </div>
                  </div>
                  <div className='data-block-body'>
                    <>
                      {numPages && (
                        <div className={(activeSheet === 0) ? 'fileCard selected' : 'fileCard'} key={'0.1'} onClick={() => this.selectDocument(0, 1)}>
                          <div className='fileCard-status'><i className="iDocIcon-file-document"/></div>
                          <div className='fileCard-Name'>
                            <div className='fileCard-miniature' style={{ backgroundImage: 'url(' + `${settings.url}document/${documentId}/preview?token=${token}&pageId=${1}&fecha=${this.state.parametroFecha}&organizedUnitId=${organizedUnitPreview}` + ')' }}></div>
                            <p>
                              <span className='fileCard-fileCount'>{/* documentId */}{t(`${tKey}SHEETS_TABLE.FILE`) + ' 1 ' + t(`${tKey}SHEETS_TABLE.DE`) + ' ' + (sheets.length + 1)}</span>
                              <span className='fileCard-fileDateText'>{t(`${tKey}SHEETS_TABLE.CREATION_DATE`)}</span>
                              <span className='fileCard-fileDate'>{this.props.docResult.incorporationDate}</span>
                            </p>
                          </div>
                          {(this.props.fleetChargeId === null || this.props.fleetChargeId === undefined) && buttonDelete && sheets.length > 0 && (
                            <OverlayTrigger placement="top" overlay={deleteSheetTooltip}>
                              <div
                                className='fileCard-delete'
                                onClick={(documentId) => {
                                  this.deleteDocumentSheet(documentId, activeSheet, organizedUnitId)
                                  this.props.trackAction(this.factoryDeleteSheetAction(documentId))
                                }} id="btn_delete_document_sheet">
                                <i className="iDocIcon-delete-forever"/>
                              </div>
                            </OverlayTrigger>
                          )}
                          <i className="selectedArrow iDocIcon-caret-right-solid"/>
                        </div>
                      )}
                      {sheets.map((sheet, idx) => {
                        return (

                          <div id={idx} className={(activeSheet === sheet.id) ? 'fileCard selected' : 'fileCard'} key={sheet.id + '.1'} onClick={() => this.selectDocument(sheet.id, 1)}>
                            <div className='fileCard-status'><i className="iDocIcon-file-document"/></div>
                            <div className='fileCard-Name'>
                              <div className='fileCard-miniature' style={{ backgroundImage: 'url(' + `${settings.url}document/${documentId}/sheet/${sheet.id}/preview?token=${token}&pageId=${1}&fecha=${this.state.parametroFecha}&organizedUnitId=${organizedUnitPreview}` + ')' }}></div>
                              <p>
                                <span className='fileCard-fileCount'>{/* documentId */}{t(`${tKey}SHEETS_TABLE.FILE`) + ' ' + (idx + 2) + ' ' + t(`${tKey}SHEETS_TABLE.DE`) + ' ' + (sheets.length + 1)}</span>
                                <span className='fileCard-fileDateText'>{t(`${tKey}SHEETS_TABLE.CREATION_DATE`)}</span>
                                <span className='fileCard-fileDate'>{sheet.creationDate}</span>
                              </p>
                            </div>
                            {(this.props.fleetChargeId === null || this.props.fleetChargeId === undefined) && buttonDelete && sheets.length > 0 && (
                              <OverlayTrigger placement="top" overlay={deleteSheetTooltip}>
                                <div
                                  className='fileCard-delete'
                                  onClick={(documentId) => {
                                    this.deleteDocumentSheet(documentId, activeSheet, organizedUnitId)
                                    this.props.trackAction(this.factoryDeleteSheetAction(documentId))
                                  }} id="btn_delete_document_sheet">
                                  <i className="iDocIcon-delete-forever"/>
                                </div>
                              </OverlayTrigger>
                            )}
                            <i className="selectedArrow iDocIcon-caret-right-solid"/>
                          </div>

                        )
                      })}
                      { buttonNewSheet && (this.props.fleetMode === null || this.props.fleetMode === undefined) &&
                      (this.props.fleetChargeId === null || this.props.fleetChargeId === undefined) && (
                        <div className="fileCard">
                          <div className={'box-add-sheet dropzone-box-wrapper-modal' + (this.state.hasInvalidFile ? ' has-error' : '')}>
                            { <DropZone
                              id="dropZone"
                              multiple={false}
                              onDrop={(acceptedFiles, rejectedFiles) => this.onDrop(acceptedFiles, rejectedFiles, organizedUnitId)}
                              accept={acceptFilesDropzone}
                              maxSize={maxSizeFilesDropzone}
                              style={{ height: '100%' }}
                              className={this.state.dropzonePanelActive ? 'active' : ''}
                              onDragEnter={() => this.onDragEnter(true)}
                              onDragLeave={() => this.onDragLeave(true)}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <div className="text-wrapper" {...getRootProps()}>
                                  <input {...getInputProps()} />
                                  <i className="ico-cloud"/>
                                  <p>
                                    {t(`${tKey}DROP_FILES_FULL`)}
                                    <br/>
                                    {this.state.hasInvalidFile && (
                                      <span className="help-block text-center">
                                        {t(`${tKey}VALIDATION.FILE`)}
                                      </span>
                                    )}
                                  </p>
                                </div>
                              )}
                            </DropZone>}
                          </div>
                        </div>
                      )
                      }
                    </>
                  </div>
                </div>
              </div>
            )}

            <div className='m-Body-Center'>
              {((!this.state.showFileUploader) && (solpheoDocumentId || storageDocumentId)) && (
                <div className="imageActions">
                  <OverlayTrigger placement="right" overlay={viewSheetTooltip} >
                    <Button className="_Btn accept stk o-icn" id="btn_view_sheet" onClick={(e) => activeSheet === 0 ? (this.toggleFullScreenDocumentModal(e)) : (this.toggleFullScreenDocumentSheetModal(e, activeSheet))}>
                      <i className="iDocIcon-search"/>
                    </Button>
                  </OverlayTrigger>
                  {buttonDownload &&
                  (<OverlayTrigger placement="right" overlay={downloadTooltip}>
                    <Button className="_Btn accept stk o-icn" id="btn_view_download" onClick={(e) => activeSheet === 0 ? (this.downloadDocument(e)) : (this.downloadDocumentSheet(e, activeSheet))}>
                      <i className='iDocIcon-cloud-download-alt-solid'/>
                    </Button>
                  </OverlayTrigger>)}
                  {this.props.fleetMode !== fleetMode.INCORPORATE_CHARGE && <OverlayTrigger placement="right" overlay={refreshTooltip}>
                    <Button className="_Btn accept stk o-icn" id="btn_view_refresh" onClick={(e) => this.refreshDocument(e)}>
                      <i className='iDocIcon-update' />
                    </Button>
                  </OverlayTrigger>}
                </div>
              )}
              <div className='imageConteiner'>
                <div className='imageSelected'>
                  <div className={'dropzone-wrapper-modal' + (this.state.hasInvalidFile || this.state.showMissingDocumentTypeError ? ' has-error' : '')} style={{ height: '100%' }}>
                    {
                      iconReload
                        ? (
                          <div onClick={() => openDocumentEditionModal(documentId, documentTypeUseId, documentParentTypeId, dossierId, entityId, vehicleId, organizedUnitId, null, callback, refreshAfterChange, dossierType, null, null, null, null, false, editable)} className="text-wrapper">
                            <img src="images/check_list.gif" alt=""/>
                            <h2>{t(`${tKey}LOADING_MESSAGE`)}</h2>
                            <p>{t(`${tKey}TRY_FETCH_DOCUMENT`)}</p>
                          </div>
                        ) : (
                          ((!this.state.showFileUploader) && (solpheoDocumentId || storageDocumentId)) ? (
                            <div id="dropZone" className="dropzone-thumbnail" style={{ height: '100%' }}>
                              {this.props.isLoading ? (
                                <div style={{ height: '100%', border: '1px solid #b1b1b1', paddingTop: '30%' }}>
                                  <SmallLoaderPage
                                    background="#ffffff"
                                  />
                                </div>
                              ) : (
                                <>
                                  <div className="dropzone-img-wrapper" style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {
                                      this.state.zoomProps.img !== '' && (
                                        <ImageZoom
                                          src={this.state.zoomProps.img}
                                          width={this.state.zoomProps.width}
                                          height={this.state.zoomProps.height}
                                          magnifierSize={300}
                                          zoomLevel={2}
                                          enabled={true}
                                        />
                                      )
                                    }
                                  </div>

                                </>
                              )}
                            </div>
                          ) : !readOnlyFields && buttonUpload && (
                            onlyTemplateUpload
                              ? <div className="text-wrapper modal-subir-fichero-inicio"
                                onClick={() => this.handleGenerateAndUploadClick()}>
                                <div>
                                  <div>
                                    <FontAwesomeIcon className="ico-document-upload" icon={faFileArrowUp} />
                                    <p className='generate-upload-subtitle'>{t(`${tKey}CLICK_HERE_FOR`)}</p>
                                    <h2 className='generate-upload-title'>{t(`${tKey}GENERATE_UPLOAD`)}</h2>
                                  </div>
                                </div>
                              </div>
                              : <DropZone
                                id="dropZone"
                                multiple={false}
                                onDrop={(acceptedFiles, rejectedFiles) => this.onDrop(acceptedFiles, rejectedFiles, organizedUnitId)}
                                disabled={(!this.state.selectedDocType && !documentTypeUseName) || !permissionToEdit}
                                accept={acceptFilesDropzone}
                                maxSize={maxSizeFilesDropzone}
                                style={{ height: '100%' }}
                                className={this.state.dropzoneActive ? 'active' : ''}
                                onDragEnter={() => this.onDragEnter(false)}
                                onDragLeave={() => this.onDragLeave(false)}
                              >
                                {({ getRootProps, getInputProps }) => (
                                  <div className="text-wrapper modal-subir-fichero-inicio" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div onClick={() => { if (!this.state.selectedDocType && !documentTypeUseName) this.setState({ showMissingDocumentTypeError: true }) }}>
                                      <div>
                                        <i className={!documentTypeUseName ? 'ico-cloud cloud-apagado' : 'ico-cloud cloud-size'}/>
                                        {!this.state.showMissingDocumentTypeError ? [
                                          <h2 key="dropZone-title">{t(`${tKey}DROP_FILES`)}</h2>,
                                          <p key="dropZone-subtitle">{this.ReturnFormatDocument(acceptFilesDropzone, tKey, t)}</p>,
                                          this.state.hasInvalidFile && <div className="help-block text-center" key="dropZone-help-block">{t(`${tKey}VALIDATION.FILE`)}</div>
                                        ] : (
                                          <h2>{t(`${tKey}VALIDATION.DOCUMENT_TYPE_REQUIRED`)}</h2>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </DropZone>
                          )
                        )
                    }
                  </div>

                </div>
                <div className='inameMiniature'>
                  {(!this.state.showFileUploader && documentId) && (
                    <div className={'carrusel-imagenes-modal ' + (buttonDownload ? 'with-download ' : '') + (numPages > this.state.carouselItemsPerPage ? '' : 'without-pagination ') + (this.state.showPageCarrusel ? '' : 'hide-page-carousel')} >
                      <div className="vertical-scroll-wrapper squares">
                        {activeSheet === 0 && numPages && (
                          (() => {
                            const pages = []
                            const initItem = this.state.carouselPaginationIdx > 1 ? (this.state.carouselPaginationIdx - 1) * this.state.carouselItemsPerPage + 1 : 1
                            let lastItem = this.state.carouselPaginationIdx ? (initItem > 1 ? initItem + this.state.carouselItemsPerPage - 1 : this.state.carouselItemsPerPage) : numPages
                            if (lastItem > numPages) {
                              lastItem = numPages
                            }
                            for (let i = initItem; i <= lastItem; i++) {
                              pages.push(
                                <div key={'0.' + i} className="img-carrusel" onClick={() => this.setActivePage(0, i)}>
                                  <ImgPage
                                    src={`${settings.url}document/${documentId}/preview?token=${token}&pageId=${i}&fecha=${this.state.parametroFecha}&organizedUnitId=${organizedUnitPreview}`}
                                    active={(this.props.activeSheet === 0 && this.props.activePage === i) ? 'img-active' : ''}
                                  />
                                </div>
                              )
                            }
                            return pages
                          })()
                        )}
                        {activeSheet !== 0 && (sheets.length > 0 || this.state.showSheets) && (
                          (() => {
                            const activeSheetIdx = sheets.findIndex((sheet, idx) => {
                              return activeSheet === sheet.id
                            })
                            const pages = []
                            if (activeSheetIdx !== -1) {
                              const activeSheet = sheets[activeSheetIdx]
                              const initItem = this.state.carouselPaginationIdx > 1 ? (this.state.carouselPaginationIdx - 1) * this.state.carouselItemsPerPage + 1 : 1
                              let lastItem = this.state.carouselPaginationIdx ? (initItem > 1 ? initItem + this.state.carouselItemsPerPage - 1 : this.state.carouselItemsPerPage) : activeSheet.numPages

                              if (lastItem > activeSheet.numPages) {
                                lastItem = activeSheet.numPages
                              }
                              for (let i = initItem; i <= lastItem; i++) {
                                pages.push(
                                  <div key={activeSheet.id + '.' + i} className="img-carrusel" onClick={() => this.setActivePage(activeSheet.id, i)}>
                                    <ImgPage
                                      src={`${settings.url}document/${documentId}/sheet/${activeSheet.id}/preview?token=${token}&pageId=${i}&fecha=${this.state.parametroFecha}&organizedUnitId=${organizedUnitPreview}`}
                                      active={(this.props.activeSheet === activeSheet.id && this.props.activePage === i) ? 'img-active' : ''}
                                    />
                                  </div>
                                )
                              }
                            }
                            return pages
                          })()
                        )}
                      </div>
                    </div>
                  )
                  }

                </div>
              </div>
            </div>

            <div className='m-Body-Right'>
              <Form autoComplete="off" className='full-height' onSubmit={handleSubmit(values => {
                this.changeAll(values)
                this.submitDocument(values)
              })} onKeyDown={(e) => handleKeyDown(e) }>
                <div className='m-Body-Right-Fields'>
                  {!documentTypeUseName && this.state.showFileUploader &&
                    <Field
                      component={InputSelect}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      controlLabel={t(`${tKey}DOCUMENT_TYPE`)}
                      id="documentType"
                      name="documentType"
                      placeholder={t(`${tKey}DOCUMENT_TYPE`)}
                      menuContainerStyle={{ zIndex: 999 }}
                      options={documentsTypes}
                      onInputChange={(value) => this.handleDocTypeChange(value)}
                      valueKey="id"
                      labelKey="value"
                      disabled={!!thumbnail}
                      customClass="select-document-management"
                    />
                  }
                  {/** REJECTED BLOCK */}
                  {comment && this.props.docResult.documentStatusId === backEndIdDocumentStatus.REJECTED && (
                    <div className={'m-data-block rejected'}>
                      <div className='data-block-header'>
                        <div className='data-block-header-name'>
                          <span>{t(`${tKey}REJECT_REASON`)}</span>
                        </div>
                      </div>
                      <div className='data-block-body'>
                        <div className='fieldsContainer'>
                          {/** REJECTED FIELDS */}
                          <SimpleInputText
                            colWidth={100} // 25, 33, 50, 75, 100 default=25
                            id='comment'
                            name='comment'
                            value={comment}
                            disabled={true}
                            componentClass="textarea"
                          />
                          {/** REJECTED FIELDS */}
                        </div>
                      </div>
                    </div>
                  )
                  }
                  {/** METADATA BLOCK */}
                  { typeView && typeView === typeViewConstant.entityValues && fields.length && this.viewFieldsFleet() ? (
                    <div className={'m-data-block ' + (this.state.dossierDataGroupMETAOpen ? 'unColapse' : 'colapse')}>
                      <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('META')} >
                        <div className='data-block-header-name'>
                          <span>{t(`${tKey}METADATA`)}</span>
                        </div>
                        <div className='data-block-header-actions'>
                          <i className="iDocIcon-caret-right-solid"></i>
                        </div>
                      </div>
                      <div className='data-block-body'>
                        {/** METADATA FIELDS */}
                        { typeView === typeViewConstant.entityValues ? (metaLoading
                          ? <SmallLoaderPage background="#ffffff" key="loader" specificComponentLoading={metaLoading ? 1 : 0 } /> : [
                            <div key="metadata" className="fieldsContainer">
                              {
                                fields.map((field, idx) => {
                                  return field.typeField !== typeFieldsConstant.licensePlateValidation ? (

                                    <SimpleInputText
                                      key={idx}
                                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                                      id={'metadata-' + field.code}
                                      value={field.metaValue ? field.metaValue : ''}
                                      controlLabel={field.name}
                                      disabled={true}
                                      paddingLeft={{ paddingLeft: '0px' }}
                                    />

                                  ) : null
                                })
                              }
                            </div>,
                            <div key="copy" className="columna-boton-copiar">
                              <OverlayTrigger placement="top" overlay={copyValuesTooltip}>
                                <Button className="_Btn accent stk o-icn" onClick={() => this.copyMetaToEntityValues()}>
                                  <i className='iDocIcon-copy-clone'/>
                                </Button>
                              </OverlayTrigger>
                            </div>
                          ]) : null
                        }
                        {/** METADATA FIELDS */}
                      </div>
                    </div>
                  ) : null
                  }
                  {/** FIELDS BLOCK */}
                  { typeView && typeView !== typeViewConstant.empty && fields.length && this.viewFieldsFleet() ? (
                    <div className={'m-data-block ' + (this.state.dossierDataGroupFIELSSOpen ? 'unColapse' : 'colapse')}>
                      <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('FIELS')} >
                        <div className='data-block-header-name'>
                          <span>{t(`${tKey}DATA_TO_FILL`)}</span>
                        </div>
                        <div className='data-block-header-actions'>
                          <i className="iDocIcon-caret-right-solid"></i>
                        </div>
                      </div>
                      <div className='data-block-body'>
                        {/** FIELDS */}
                        <div className='fieldsContainer dossier-Component'>
                          {
                            fields.map((field, idx) => (
                              <>
                                {(() => {
                                  switch (field.typeField) {
                                    case typeFieldsConstant.number:
                                      return (
                                        <Field
                                          component={InputNatural}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25 colSm={6}
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          disabled= {(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                          textAlign="right"
                                          maxLength = {field.maxLength ?? null}
                                          key={idx}
                                        />
                                      )
                                    case typeFieldsConstant.money:
                                      return (
                                        <Field
                                          component={InputMoney}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          disabled={(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                          textAlign="right"
                                          validate={[this.customValidate]}
                                          onInputChange={(event) => this.isFunctionToBeExecutedInFrontActive() && this.executeFieldFunction(field, fields, event.target.value)}
                                          maxLength = {field.maxLength ?? null}
                                          key={idx}
                                        />
                                      )
                                    case typeFieldsConstant.decimal:
                                      return (
                                        <Field
                                          component={InputDecimal}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          disabled= {(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                          textAlign="right"
                                          maxLength = {field.maxLength ?? null}
                                          key={idx}
                                        />
                                      )
                                    case typeFieldsConstant.date:
                                      return (
                                        <Field
                                          component={InputDatePicker}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          validate= {this.validateDate}
                                          disabled= {(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                          customClass={(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave) ? 'disabled' : ''}
                                          paddingLeft={{ paddingLeft: '0px' }}
                                          key={idx}
                                        />
                                      )
                                    case typeFieldsConstant.list:
                                      return (
                                        <Field
                                          component={InputSelect}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          placeholder={field.name}
                                          options={field.options}
                                          valueKey="id"
                                          labelKey="value"
                                          disabled= {((!(documentId && !validatedText) || field.isReadOnly) && !field.isEnabled && (this.state.canSave === undefined || !this.state.canSave)) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                          paddingLeft={{ paddingLeft: '0px' }}
                                          key="select-document"
                                          onInputChange={(value) => this.ChangesList(value, field.fieldId, field.notDocument, documentId)}
                                        />)
                                    case typeFieldsConstant.licensePlate:
                                      return (
                                        <Field
                                          component={InputText}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          key={'entityValue.' + field.fieldId}
                                          placeholder={field.name}
                                          normalize={value => multipleNormalize(value, [toUpperCase, trimAll])}
                                          disabled={(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                          textAlign="left"
                                        />
                                      )
                                    case typeFieldsConstant.vinChassis:
                                      return (
                                        <Field
                                          component={InputText}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          maxLength={17}
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          placeholder={field.name}
                                          normalize={value => multipleNormalize(value, [toUpperCase, trimAll])}
                                          disabled= {(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                          textAlign="left"
                                          key={idx}
                                        />
                                      )
                                    case typeFieldsConstant.licensePlateValidation:
                                      return ([
                                        <Field
                                          component={InputCheckBox}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          customClass="disable-license-plate-checkbox"
                                          controlLabel={field.name}
                                          id={field.code}
                                          tooltip={editTooltip}
                                          tooltipPosition='left'
                                          name={'entityValue.' + field.fieldId}
                                          key={'entityValue.' + field.fieldId}
                                          placeholder={field.name}
                                          disabled= {(!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit || documentId === null || (!buttonValidate && !buttonSave)}
                                        />
                                      ])
                                    default:
                                      return (
                                        <Field
                                          component={InputText}
                                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                                          controlLabel={field.name}
                                          id={field.code}
                                          name={'entityValue.' + field.fieldId}
                                          placeholder={field.name}
                                          disabled={((!(documentId && !validatedText) || field.isReadOnly) || !permissionToEdit) && !field.isEnabled && (this.state.canSave === undefined || !this.state.canSave) || (!buttonValidate && !buttonSave) }
                                          textAlign="left"
                                          maxLength = {field.maxLength ?? null}
                                          style={{ display: field.fieldDependenceId && this.state.invisible ? 'none' : 'block' }}
                                          key={idx}
                                        />
                                      )
                                  }
                                })()}
                              </>
                            ))
                          }
                        </div>
                        {!permissionToEdit &&
                            <Row className="permission-recurrent-entity-invalid">
                              {t(`${tKey}PERMISSION_RECURRENT_ENTITY_INVALID`)}
                            </Row>
                        }
                        {/** FIELDS */}
                      </div>
                    </div>
                  ) : null
                  }
                  {/** OBSERVATIONS BLOCK */}
                  { this.props.docResult.documentStatusId !== backEndIdDocumentStatus.REJECTED && commentDocument && this.viewFieldsFleet() && (
                    <div className={'m-data-block ' + (this.state.dossierDataGroupOBSERVATIONSOpen ? 'unColapse' : 'colapse')}>
                      <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('OBSERVATIONS')} >
                        <div className='data-block-header-name'>
                          <span>{t(`${tKey}TEXT`)}</span>
                        </div>
                        <div className='data-block-header-actions'>
                          <i className="iDocIcon-caret-right-solid"></i>
                        </div>
                      </div>
                      <div className='data-block-body'>
                        {/** FIELDS */}
                        <Field
                          component={InputText}
                          colWidth={100} // 25, 33, 50, 75, 100 default=25
                          id='comment'
                          name='comment'
                          componentClass="textarea"
                          colSm={12}
                          placeholder={t(`${tKey}TEXT`)}
                          customClass="comment-reject-modal-textarea"
                          textAlign="left"
                          paddingLeft={{ paddingLeft: '0px' }}
                          disabled={(!(documentId && !validatedText)) && this.props.fleetMode !== fleetMode.REEDIT}
                        />
                        {/** FIELDS */}
                      </div>
                    </div>
                  )
                  }
                </div>
                <div className='m-Body-Right-Actions'>
                  <div className='m-data-block actions '>
                    <div className='data-block-header' onClick={() => this.toggleDossierDataGroup('ACTIONS')} >
                      <div className='data-block-header-name'>
                        <span>{t(`${tKey}ACTIONS`)}</span>
                      </div>
                      {/* <div className='data-block-header-actions'>
                        <i className="iDocIcon-caret-right-solid"></i>
                      </div> */}
                    </div>
                    <div className='data-block-body'>
                      <div className='btnContainer'>
                        {(!readOnlyFields && !this.state.showFileUploader || this.state.canSave) && (this.props.fleetMode === null || this.props.fleetMode === undefined) && (
                          <>
                            {/* ACTIONS BUTTONS HERE */}
                            { !readOnlyFields && buttonAddNewVersion && permissionToEdit && (
                              <OverlayTrigger placement="top" overlay={uploadNewVersionTooltip}>
                                <Button className="_Btn accent stk" onClick={this.uploadNewVersion.bind(this)} id="btn_new_version">
                                  <i className="iDocIcon-repeat-barter"></i>{t(`${tKey}UPLOAD_NEW_VERSION`)}
                                </Button>
                              </OverlayTrigger>
                            )}
                            {(!fleetsVisor && (buttonValidate || buttonReject) && (solpheoDocumentId || storageDocumentId)) ? [buttonValidate && permissionToEdit &&
                              (
                                <Button
                                  id="btn_validate"
                                  key="btn_validate"
                                  className="_Btn new stk"
                                  onClick={handleSubmit(values => {
                                    this.changeAll(values)
                                    this.props.fleetChargeId && this.props.fleetChargeId > 0 ? this.validateFleetDocument({ ...values }) : this.submitDocument({ ...values, validateAction: true })
                                  })}
                                >
                                  <i className="ico-check"/> {t(`${tKey}VALIDATE_BTN`)}
                                </Button>
                              ),
                            buttonReject && permissionToEdit && (
                              <Button
                                id="btn_reject"
                                key="btn_reject"
                                className="_Btn cancel stk"
                                onClick={() => this.setState({ showRejectCommentModal: true })}
                              >
                                <i className="ico-cancel"/> {t(`${tKey}REJECT_BTN`)}
                              </Button>
                            ),
                            (settings.showSignDocumentButton && dossierType === dossierTypesConstant.sales && dossierSubType === dossierSubTypeIdConstants.venta_vn && documentTypeUseId === 4) && ( // Recibo de paga y señal
                              <Button
                                id="btn_sign"
                                key="btn_sign"
                                className="_Btn accent"
                                onClick={() => {
                                  const signAppUrl = `http://signidoccar.premm.es/?entorno=${encodeURIComponent(settings.url)}&token=${token}&checkListId=${checkListIdReciboPagaYSenal}&organizedUnitId=${organizedUnitId}&documentTypeId=${documentTypeUseId}&id=${dossierId}&documentId=${documentId}&fecha=${this.state.parametroFecha}`
                                  window.open(signAppUrl, '_blank')
                                }}
                              >
                                <i className="iDocIcon-signature-draw"></i>{t(`${tKey}SIGN_BTN`)}
                              </Button>
                            )] : null
                            }
                            {(buttonSeal && permissionToEdit && (solpheoDocumentId || storageDocumentId)) &&
                              <Button
                                id="btn_seal"
                                className="_Btn accent"
                                onClick={() => this.sealDocument(documentId, dossierId)}>
                                {t(`${tKey}SEAL`)}
                              </Button>
                            }
                            {btnRequestSign &&
                              <Button
                                id="btn_request_sign"
                                className="_Btn accent"
                                onClick={handleSubmit(values => {
                                  this.signDocument(values, fleetsVisor)
                                  this.props.trackAction(this.factorySignRequestAction(documentId))
                                })}>
                                {t(`${tKey}REQUEST_SIGN`)}
                              </Button>
                            }
                            { btnCancelSign &&
                              <Button
                                id="btn_cancel_sign"
                                className="_Btn cancel stk"
                                onClick={() => {
                                  this.openCancelSignModal()
                                  this.props.trackAction(this.factorySignCancelAction(documentId))
                                }}
                              >
                                {t(`${tKey}CANCEL_TO_SIGN`)
                                }</Button>
                            }
                            { ((buttonSave && (!solpheoDocumentId || !storageDocumentId)) && permissionToEdit) &&
                            <Button
                              id="btn_save"
                              className="_Btn new"
                              onClick={handleSubmit(values => {
                                this.changeAll(values)
                                this.submitDocument(values, fleetsVisor)
                              })}
                              type="submit">
                              {t(`${tKey}SAVE_BTN`)}
                            </Button>
                            }
                            { (buttonDMS && permissionToEdit) &&
                            <Button
                              id="btn_sendDMS"
                              className="_Btn accent"
                              onClick={() => this.sendDMS()}
                            >{t(`${tKey}SEND_DMS`)}</Button>
                            }
                            { (buttonRecover && permissionToEdit) &&
                            <Button
                              id="btn_recover"
                              className="_Btn accept"
                              onClick={() =>
                                this.props.fleetChargeId && this.props.fleetChargeId > 0
                                  ? this.recoverDocumentFleetCharge()
                                  : recoverDocument(documentId, documentTypeUseId, documentParentTypeId, dossierId, entityId, vehicleId, organizedUnitId, null, callback, refreshAfterChange, dossierType, dossierSubType, isRecurrent)}
                            >{t(`${tKey}RECOVER`)}</Button>
                            }
                            { (buttonCancel && permissionToEdit && (solpheoDocumentId || storageDocumentId)) &&
                            <Button
                              id="btn_cancel"
                              className="_Btn cancel"
                              onClick={() =>
                                this.props.fleetChargeId && this.props.fleetChargeId > 0
                                  ? this.cancelDocumentFleet()
                                  : this.cancelDocument(dossierType, documentId, documentParentTypeId, dossierId, isRecurrent, fleetsVisor)}
                            >{t(`${tKey}CANCEL`)}</Button>
                            }
                          </>
                        )}
                        {(showGenerateButtons && !this.props.docResult.documentId) &&
                              <>
                                <Button
                                  id="btn_generate"
                                  className="_Btn accent stk"
                                  onClick={() => this.printTemplate()}
                                >{t(`${tKey}GENERATE`)}
                                </Button>
                                <Button
                                  id="btn_generate_upload"
                                  className="_Btn accent"
                                  onClick={() => this.handleGenerateAndUploadClick()}
                                >{t(`${tKey}GENERATE_UPLOAD`)}
                                </Button>
                              </>
                        }
                        {/* Fleet Mode Buttons */}
                        {((!readOnlyFields && !this.state.showFileUploader || this.state.canSave) && (this.props.fleetMode !== null && this.props.fleetMode !== undefined)) && (
                          <>
                            { (buttonSave && (!solpheoDocumentId || !storageDocumentId)) && permissionToEdit && this.props.fleetMode === fleetMode.INCORPORATE_CHARGE &&
                              <Button
                                id="btn_save_fleet_document"
                                className="_Btn new"
                                onClick={handleSubmit(values => {
                                  this.changeAll(values)
                                  this.props.actions.setOperateDataChargeFleetProcess(this.props.docResult.documentId, this.props.organizedUnitId, this.props.dossieFleetIds,
                                    this.props.docResult.fields.map(field => {
                                      return {
                                        ...field, entityValue: values.entityValue[field.fieldId]
                                      }
                                    }),
                                    values.comment, this.props.fleetId, () => { this.props.actions.closeAddOrEditDocumentModalSuccess() })
                                })}
                                type="submit">
                                <i className='iDocIcon-save'/>{t(`${tKey}SAVE_BTN`)}
                              </Button>
                            }
                            {(buttonCancel && permissionToEdit && (solpheoDocumentId || storageDocumentId) && this.props.fleetMode === fleetMode.INCORPORATE_CHARGE) &&
                              <Button
                                id="btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.props.actions.closeAddOrEditDocumentModalSuccess()}>
                                {t(`${tKey}CANCEL`)}
                              </Button>
                            }
                            {(buttonSave && (!solpheoDocumentId || !storageDocumentId)) && permissionToEdit &&
                            (this.props.fleetMode === fleetMode.INCORPORATE || this.props.fleetMode === fleetMode.INCORPORATE_VALIDATE || this.props.fleetMode === fleetMode.INCORPORATE_OTHER_DOCUMENTS) &&
                              <Button
                                id="btn_save_fleet_document"
                                className="_Btn new"
                                onClick={handleSubmit(values => {
                                  this.changeAll(values)
                                  this.submitFleetDocument(values)
                                })}
                                type="submit">
                                {t(`${tKey}SAVE_BTN`)}
                              </Button>
                            }
                            {buttonCancel && permissionToEdit && (solpheoDocumentId || storageDocumentId) &&
                            (this.props.fleetMode === fleetMode.INCORPORATE || this.props.fleetMode === fleetMode.INCORPORATE_VALIDATE || this.props.fleetMode === fleetMode.INCORPORATE_OTHER_DOCUMENTS) &&
                              <Button
                                id="btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.closeModalFleet()}>
                                {t(`${tKey}CANCEL`)}
                              </Button>
                            }
                            { this.props.fleetMode === fleetMode.VALIDATE ? [(
                              <Button
                                id="btn_validate_fleet_document"
                                key="btn_validate_fleet_document"
                                className="_Btn new stk"
                                onClick={handleSubmit(values => {
                                  this.changeAll(values)
                                  this.validateFleetDocument({ ...values })
                                })}>
                                <i className="ico-check"/> {t(`${tKey}VALIDATE_BTN`)}
                              </Button>
                            ), (
                              <Button
                                id="btn_cancel"
                                key="validate_btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.directCloseModal()}>
                                <i className="ico-cancel"/> {t(`${tKey}CANCEL_BTN`)}
                              </Button>
                            )] : null
                            }
                            { this.props.fleetMode === fleetMode.INCORPORATED_CHARGE ? [
                              (<Button
                                id="btn_validate_fleet_document"
                                key="incorporated_charge_btn_validate"
                                className="_Btn new stk"
                                onClick={handleSubmit(values => {
                                  this.changeAll(values)
                                  this.validateFleetDocument({ ...values })
                                })}
                              ><i className="ico-check"/> {t(`${tKey}VALIDATE_BTN`)}</Button>),
                              (
                                <Button
                                  id="btn_reject_fleet_document"
                                  key="incorporated_charge_btn_reject"
                                  className="_Btn cancel stk"
                                  onClick={() => this.rejectDocument()}
                                ><i className="ico-cancel"/> {t(`${tKey}REJECT_BTN`)}</Button>
                              ),
                              (
                                <Button
                                  id="btn_save_fleet_document"
                                  key="incorporated_charge_btn_save"
                                  className="_Btn new"
                                  onClick={handleSubmit(values => {
                                    this.changeAll(values)
                                    this.submitFleetDocument(values)
                                  })}
                                  type="submit">
                                  {t(`${tKey}SAVE_BTN`)}
                                </Button>
                              ),
                              (
                                <Button
                                  id="btn_cancel_fleet_document"
                                  key="incorporated_charge_btn_cancel"
                                  className="_Btn cancel"
                                  onClick={() => this.cancelDocumentFleet()}
                                >{t(`${tKey}CANCEL`)}</Button>
                              ),
                              (<Button
                                id="btn_cancel"
                                key="incorporated_charge_btn_reject_cancel"
                                className="_Btn cancel"
                                onClick={() => this.directCloseModal()}
                              ><i className="ico-cancel"/> {t(`${tKey}CANCEL_BTN`)}</Button>
                              )
                            ] : null
                            }
                            { this.props.fleetMode === fleetMode.VALIDATED_CHARGE ? [
                              (
                                <Button
                                  id="btn_reject_fleet_document"
                                  key="incorporated_charge_btn_reject"
                                  className="_Btn cancel stk"
                                  onClick={() => this.rejectDocument()}
                                ><i className="ico-cancel"/> {t(`${tKey}REJECT_BTN`)}</Button>
                              ),
                              (
                                <Button
                                  id="btn_recover_fleet_document"
                                  key="btn_recover_fleet_document"
                                  className="_Btn accept"
                                  onClick={() => this.recoverDocumentFleetCharge()}>
                                  {t(`${tKey}RECOVER`)}
                                </Button>
                              )
                            ] : null
                            }
                            { this.props.fleetMode === fleetMode.REJECTED_CHARGE ? [
                              (
                                <Button
                                  id="btn_save_fleet_document"
                                  key="incorporated_charge_btn_save"
                                  className="_Btn new"
                                  onClick={handleSubmit(values => {
                                    this.changeAll(values)
                                    this.submitFleetDocument(values)
                                  })}
                                  type="submit">
                                  {t(`${tKey}SAVE_BTN`)}
                                </Button>
                              ),
                              (
                                <Button
                                  id="btn_cancel_fleet_document"
                                  key="incorporated_charge_btn_cancel"
                                  className="_Btn cancel"
                                  onClick={() => this.cancelDocumentFleet()}
                                >{t(`${tKey}CANCEL`)}</Button>
                              )
                            ] : null
                            }
                            { this.props.fleetMode === fleetMode.REEDIT ? [(
                              <Button
                                id="btn_recover_fleet_document"
                                key="btn_recover_fleet_document"
                                className="_Btn accept"
                                onClick={() => this.recoverDocumentFleet(documentId, documentTypeUseId, documentParentTypeId, dossierId, entityId, vehicleId, organizedUnitId, null, callback, refreshAfterChange, dossierType, dossierSubType, isRecurrent)}>
                                {t(`${tKey}RECOVER`)}
                              </Button>
                            ), (
                              <Button
                                id="btn_cancel"
                                key="reedit_btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.directCloseModal()}>
                                <i className="ico-cancel"/> {t(`${tKey}CANCEL_BTN`)}
                              </Button>
                            )] : null
                            }
                            { this.props.fleetMode === fleetMode.CANCEL ? [(
                              <Button
                                id="btn_cancel_fleet_document"
                                key="btn_cancel_fleet_document"
                                className="_Btn cancel"
                                onClick={() => this.cancelDocumentFleet()}>
                                {t(`${tKey}CANCEL`)}
                              </Button>
                            ), (
                              <Button
                                id="btn_cancel"
                                key="cancel_btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.directCloseModal()}>
                                <i className="ico-cancel"/> {t(`${tKey}CANCEL_BTN`)}
                              </Button>
                            )] : null
                            }
                            { this.props.fleetMode === fleetMode.REQUEST_SIGN ? [(
                              <Button
                                id="btn_request_sign_fleet"
                                key="btn_request_sign_fleet"
                                className="_Btn accent"
                                onClick={handleSubmit(values => {
                                  this.signDocument(values, fleetsVisor)
                                })}>
                                {t(`${tKey}REQUEST_SIGN`)}
                              </Button>
                            ), (
                              <Button
                                id="btn_cancel"
                                key="request_sign_btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.directCloseModal()}>
                                <i className="ico-cancel"/> {t(`${tKey}CANCEL_BTN`)}
                              </Button>
                            )] : null
                            }
                            { this.props.fleetMode === fleetMode.CANCEL_SIGN ? [(
                              <Button
                                id="btn_cancel_sign_fleet"
                                key="btn_cancel_sign_fleet"
                                className="_Btn cancel stk"
                                onClick={() => this.cancelSignDocument()}>
                                {t(`${tKey}CANCEL_TO_SIGN`)}
                              </Button>
                            ), (
                              <Button
                                id="btn_cancel"
                                key="cancel_sign_btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.directCloseModal()}>
                                <i className="ico-cancel"/> {t(`${tKey}CANCEL_BTN`)}
                              </Button>
                            )] : null
                            }
                            { this.props.fleetMode === fleetMode.REJECT ? [(
                              <Button
                                id="btn_reject_fleet_document"
                                key="btn_reject_fleet_document"
                                className="_Btn cancel stk"
                                onClick={() => this.rejectDocumentFleet()}>
                                <i className="ico-cancel"/> {t(`${tKey}REJECT_BTN`)}
                              </Button>
                            ), (
                              <Button
                                id="btn_cancel"
                                key="reject_btn_cancel"
                                className="_Btn cancel"
                                onClick={() => this.directCloseModal()}>
                                <i className="ico-cancel"/> {t(`${tKey}CANCEL_BTN`)}
                              </Button>
                            )] : null
                            }
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

              </Form>
            </div>

            <div className='m-Body-ModaldContainer'>
              <ReservationContractModalPage
                onClose={(values, printCheckList, checklistId) => this.handleSubmitReservationContractModal(values, printCheckList, checklistId)}
              />
              <ResponsibleDeclarationDocModalPage/>
              <InternalManagementDocModalPage/>
              {this.state.showRejectCommentModal && <RejectCommentModal
                t={t}
                showModal={this.state.showRejectCommentModal}
                actions={{
                  rejectAction: this.rejectDocument,
                  closeModal: () => this.setState({ showRejectCommentModal: false })
                }}
              />}
              <CancelSignModal
                t={t}
                showModal={this.state.showCancelSignModal}
                cancelDocList={this.state.cancelDocList}
                forceCancelDocument = {this.props.docResult.forceCancelDocument}
                actions={{
                  rejectAction: cancelSignMessage,
                  closeModal: () => this.setState({ showCancelSignModal: false }),
                  cancelSign,
                  callback
                }}
                documentId={documentId}
                refreshAfterChange={refreshAfterChange}
                multipleSignCancel={multipleSignCancel}
              />
              <SignTypesModal
                t={t}
                showModal={this.state.showSignTypesModal}
                closeModalAction = {this.closeModalAction.bind(this)}
                actions={{
                  requestSign,
                  createRequestSignDocumentFleetProcess,
                  closeAddOrEditDocumentModalSuccess
                }}
                documentId = {documentId}
                callback = {callback}
                refreshAfterChange = {refreshAfterChange}
                signTypesCombo = {this.state.signTypesCombo}
                fleetMode = {this.props.fleetMode}
                fleetDocumentDetails = {this.props.fleetDocumentDetails}
                fleetId = {this.props.fleetId}
              />
            </div>
          </Modal.Body>

        </Modal>
      </>
    )
  }
}
function validateFunction ({ entityValue = {} }, props) {
  const tKey = 'DOSSIER_COMPONENTS.DOCUMENTARY_MANAGEMENT.ADD_OR_EDIT_DOCUMENT.VALIDATION.'
  const error = { entityValue: {} }
  const { docResult: { fields = [] }, t } = props
  let aux
  const checkValidateLicensePlate = fields.find(f => f.typeField === typeFieldsConstant.licensePlateValidation)
  fields.forEach(field => {
    if (field.customValidations && field.customValidations.indexOf('regEx-') !== -1) {
      var value = entityValue[field.fieldId.toString()]

      if (value && (field.typeField === typeFieldsConstant.decimal || field.typeField === typeFieldsConstant.money)) {
        value = value.replace(',', '.')
        var parts = value.split('.')
        var wholePart = parts[0]
        var decimalPart = parts[1] ? parts[1].slice(0, 2) : ''
        if (decimalPart.length > 2) {
          decimalPart = decimalPart.slice(0, 2)
        }
        value = decimalPart ? wholePart + '.' + decimalPart : wholePart
      }

      aux = validateRegex(field.customValidations, field.name, value, props)

      if (aux !== Object(aux)) {
        error.entityValue[field.fieldId.toString()] = aux
      }
    }
    if (field.typeField === typeFieldsConstant.licensePlate && (!checkValidateLicensePlate || !entityValue[checkValidateLicensePlate.fieldId.toString()] || entityValue[checkValidateLicensePlate.fieldId.toString()] === 'False')) {
      var validateLicensePlateCountry = props?.docResult?.data?.validateLicensePlateCountry
      aux = validateLicensePlateFunciton(entityValue[field.fieldId.toString()], validateLicensePlateCountry || false, props.t('GLOBAL.FORMS.INVALID_STRING'))
      if (aux && aux !== Object(aux)) {
        error.entityValue[field.fieldId.toString()] = aux
      }
    }

    validateMetadatoByCode(entityValue, field, props, error)

    if (field.isMandatory && !entityValue[field.fieldId.toString()]) error.entityValue[field.fieldId.toString()] = t(`${tKey}MANDATORY`)
  })
  return error
}
var decoratedComponent = TrackingContainer(DocumentEdition, false)
export default reduxForm({
  form: 'AddOrEditDocumentForm',
  validate: validateFunction,
  destroyOnUnmount: false
})(decoratedComponent)
